import React, { useState, useEffect, useMemo } from "react";
import { Drawer, message, Empty, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { useAISidebarSearch } from "./customHooks/useAISidebarSearch";
import { SearchOutlined } from "@ant-design/icons";
import { detectAILeaveAction } from "./leaveActionHandler";

import dayjs from "dayjs";
import { getAIChatResponse } from "./aiSmallTalk";
import { detectDashboardIntent } from "./detectDashboardIntent";
import { Mic } from "react-feather";
import { detectDepartmentIntent } from "./department/detectDepartmentIntent";
import { processPendingDeleteDepartment, processPendingDepartment, startCreateDepartmentFlow, startDeleteDepartmentFlow } from "./department/aiDepartmentCreateHandler";
import { processPendingProfileUpdate, startProfileUpdateFlow } from "./profile/aiProfileUpdateHandler";
import { detectProfileIntent } from "./profile/detectProfileIntent";
import { detectHolidayIntent } from "./holiday/detectHolidayIntent";
import { startCreateHolidayFlow, processPendingHoliday, startDeleteHolidayFlow, processPendingDeleteHoliday } from "./holiday/aiHolidayCreateHandler";
import { detectDesignationIntent } from "./designation/detectDesignationIntent";
import { processPendingDeleteDesignation, processPendingDesignation, startCreateDesignationFlow, startDeleteDesignationFlow } from "./designation/aiDesignationCreateHandler";
import { processPendingDeletePolicy, processPendingPolicy, startCreatePolicyFlow, startDeletePolicyFlow } from "./policies/aiPolicyCreateHandler";
import { detectPolicyIntent } from "./policies/detectPolicyIntent";
import { processPendingDeleteSkill, processPendingSkill, startCreateSkillFlow, startDeleteSkillFlow } from "./skills/aiSkillCreateHandler";
import { detectSkillIntent } from "./skills/detectSkilIntend";
import { processPendingDeleteWeeklyOff, processPendingWeeklyOff, startCreateWeeklyOffFlow, startDeleteWeeklyOffFlow } from "./weekly-off/aiWeeklyOffCreateHandler";
import { detectWeeklyOffIntent } from "./weekly-off/detectWeeklyOffIntent";
import { useDispatch, useSelector } from "react-redux";
import { filterByStatus } from "../utils/filterActiveData";
import { detectExperienceIntent } from "./experience/detectExperienceIntent";
import { processPendingDeleteExperience, processPendingExperience, startCreateExperienceFlow, startDeleteExperienceFlow } from "./experience/aiExperienceCreateHandler";
import { processPendingDeleteTicket, processPendingTicket, startCreateTicketFlow, startDeleteTicketFlow } from "./tickets/aiTicketCreateHandler";
import { detectTicketIntent } from "./tickets/detectTicketIntent";
import { detectTicketCategoryIntent } from "./ticket_category/detectTicketCategoryIntent";
import { processPendingDeleteTicketCategory, processPendingTicketCategory, startCreateTicketCategoryFlow, startDeleteTicketCategoryFlow } from "./ticket_category/aiTicketCategoryCreateHandler";
import { detectCalendarIntent } from "./calendar/detectCalendarIntent";
import { processPendingDeleteTask, processPendingTask, startCreateTaskFlow, startDeleteTaskFlow } from "./calendar/aiCalendarCreateHandler";
import { detectLeaveAdminIntent } from "./attendance/leaves/leave_admin/detectLeaveAdminIntent";
import { processPendingDeleteLeaveAdmin, processPendingLeaveAdmin, startCreateLeaveAdminFlow, startDeleteLeaveAdminFlow } from "./attendance/leaves/leave_admin/aiLeaveAdminCreateHandler";
import { detectShiftScheduleIntent } from "./attendance/shift_schedule/detectSchiftScheduleIntent";
import { processPendingDeleteShiftSchedule, processPendingShiftSchedule, startCreateShiftScheduleFlow, startDeleteShiftScheduleFlow } from "./attendance/shift_schedule/aiShiftScheduleCreateHandler";
import { detectFinancialYearIntent } from "./financial_year/detectFinancialYearIntent";
import { processPendingFinancialYear, processPendingUpdateFinancialYear, startCreateFinancialYearFlow, startUpdateFinancialYearFlow } from "./financial_year/aiFinancialYearCreateHandler";
import { detectGoalTypeIntent } from "./goal_type/detectGoalTypeIntent";
import { processPendingDeleteGoalType, processPendingGoalType, startCreateGoalTypeFlow, startDeleteGoalTypeFlow } from "./goal_type/aiGoalTypeCreateHandler";
import { processPendingDeleteGoal, processPendingGoal, startCreateGoalFlow, startDeleteGoalFlow } from "./goal/aiGoalCreateHandler";
import { detectGoalIntent } from "./goal/detectGoalIntent";
import { processPendingDeleteEmployee, processPendingEmployee, processPendingUpdateEmployee, startCreateEmployeeFlow, startDeleteEmployeeFlow, startUpdateEmployeeFlow } from "./employee/aiEmployeeCreateHandler";
import { detectEmployeeIntent } from "./employee/detectEmployeeIntent";
import { detectTrainingListIntent } from "./trainningLIst/detectTrainningListIntent";
import { processPendingDeleteTraining, processPendingTraining, startCreateTrainingFlow, startDeleteTrainingFlow } from "./trainningLIst/aiTrainningListCreateHandler";
import { detectTrainerIntent } from "./trainers/detectTrainerIntent";
import { processPendingDeleteTrainer, processPendingTrainer, startCreateTrainerFlow, startDeleteTrainerFlow } from "./trainers/aiTrainersCreateHandler";
import { processPendingDeleteTrainingType, processPendingTrainingType, startCreateTrainingTypeFlow, startDeleteTrainingTypeFlow } from "./trainingType/aiTrainingTypeCreateHandler";
import { detectTrainingTypeIntent } from "./trainingType/detectTrainingTypeIntent";
import { detectAssetCategoryIntent } from "./Asset/assetCategory/detectAssetCategoryIntent";
import { processPendingAssetCategory, processPendingDeleteAssetCategory, startCreateAssetCategoryFlow, startDeleteAssetCategoryFlow } from "./Asset/assetCategory/aiAssetCategoryCreateHandler";
import { processPendingAssetRequest, processPendingDeleteAssetRequest, startCreateAssetRequestFlow, startDeleteAssetRequestFlow } from "./Asset/assetRequest/aiAssetRequestCreateHandler";
import { detectAssetRequestIntent } from "./Asset/assetRequest/detectAssetRequestIntent";
import { detectPromotionIntent } from "./promotion/detectPromotionIntent";
import { processPendingDeletePromotion, processPendingPromotion, startCreatePromotionFlow, startDeletePromotionFlow } from "./promotion/aiPromotionCreateHandler";
import { detectBranchIntent } from "./branch/detectBranchCategoryIntent";
import { processPendingBranch, processPendingDeleteBranch, startCreateBranchFlow, startDeleteBranchFlow } from "./branch/aiBranchCategoryCreateHandler";
import { processPendingDeleteTermination, processPendingTermination, startCreateTerminationFlow, startDeleteTerminationFlow } from "./termination/aiTerminationCreateHandler";
import { detectTerminationIntent } from "./termination/detectTerminationIntent";
import { ActiveFlow } from "./master";
import Enum from "../../core/common/Enum/enum";
import { processPendingDeleteResignation, processPendingResignation, startCreateResignationFlow, startDeleteResignationFlow } from "./resignation/aiResignationCreateHandler";
import { detectResignationIntent } from "./resignation/detectResignationIntent";
import { fetchEmployeeDetailsById, getAllHODsAndHr } from "../data/redux/resignation/resignationAction";
import { AppDispatch } from "../data/redux/store";
import { processPendingClient, processPendingDeleteClient, startCreateClientFlow, startDeleteClientFlow } from "./client/aiClientCreateHandler";
import { detectClientIntent } from "./client/detectClientIntent";
import { processPendingDeleteTaskBoard, processPendingTaskBoard, startCreateTaskBoardFlow, startDeleteTaskBoardFlow } from "./projects&Task/taskboard/aiTaskboardCreateHandler";
import { detectTaskboardIntent } from "./projects&Task/taskboard/detectTaskboardIntent";
import { processPendingDeleteProjectTask, processPendingProjectTask, startCreateProjectTaskFlow, startDeleteProjectTaskFlow } from "./projects&Task/projects/aiTasksCreateHandler";
import { detectProjectTaskIntent } from "./projects&Task/projects/detectTasksIntent";
import { processPendingDeleteTimesheet, processPendingTimesheet, startCreateTimesheetFlow, startDeleteTimesheetFlow } from "./projects&Task/timesheet/aiTimesheetCreateHandler";
import { detectTimesheetIntent } from "./projects&Task/timesheet/detectTimesheetIntend";
import { detectEmployeeMappingIntent } from "./general_provident_fund/employee_mapping/detectEmployeeMappingIntent";
import { processPendingDeleteEmployeeMapping, processPendingEmployeeMapping, startCreateEmployeeMappingFlow, startDeleteEmployeeMappingFlow } from "./general_provident_fund/employee_mapping/aiEmployeeMappingCreateHandler";
import { processPendingAutoPf, startCreateAutoPfFlow } from "./general_provident_fund/monthly_contribution/aiMonthlyContributonCreateHandler";
import { detectEmployeeAutoContributionIntent } from "./general_provident_fund/monthly_contribution/detectMonthlyContributionIntent";
import { processPendingPfWithdrawal, startCreatePfWithdrawalFlow } from "./general_provident_fund/withdrawal_request/aiWithdrawalRequestCreateHandler";
import { detectPfWithdrawalIntent } from "./general_provident_fund/withdrawal_request/detectWithdrawalRequestIntent";
import { fetchAllPfPolicies } from "../data/redux/payroll/Accounting/providentFund/pfpolicies/pfPolicyActions";
import { getEmployees } from "../data/redux/employee/employeeAction";
import { processPendingDeletePfLoan, processPendingPfLoan, startCreatePfLoanFlow, startDeletePfLoanFlow } from "./general_provident_fund/loan_request/aiLoadRequestCreateHandler";
import { detectLoanRequestIntent } from "./general_provident_fund/loan_request/detectLoanRequestIntent";
import { processPendingDeletePfPolicy, processPendingPfPolicy, startCreatePfPolicyFlow, startDeletePfPolicyFlow } from "./general_provident_fund/settings_policies/aiSettingsPoliciesCreateHandler";
import { detectPfPolicyIntent } from "./general_provident_fund/settings_policies/detectSettingPoliciesIntent";
import { detectTDSlabIntent } from "./tds/tds_slab/detectTDSlabIntent";
import { PendingDeleteTax, PendingTax, processPendingDeleteTax, processPendingTax, startCreateTaxFlow, startDeleteTaxFlow } from "./tds/tds_slab/aiTDSlabCreateHandler";
import { detectTaxRegimeIntent } from "./tds/tax-regime-config/detectTRCIntent";
import { processPendingDeleteTaxRegime, processPendingTaxRegime, startCreateTaxRegimeFlow, startDeleteTaxRegimeFlow } from "./tds/tax-regime-config/aiTRcCreateHandler";
import { processPendingDeleteTdsSurchargeCess, processPendingTdsSurchargeCess, startCreateTdsSurchargeCessFlow, startDeleteTdsSurchargeCessFlow } from "./tds/surcharge&Cess/aisurcharge&cessCreateHandler";
import { detectSurchargeIntent } from "./tds/surcharge&Cess/detectSurcharge&cessIntent";
import { detectEmployeeContributionIntent } from "./tds/employee_contribution/detectEmployeeContributionIntent";
import { processPendingAutoTds, startAutoProcessTdsFlow } from "./tds/employee_contribution/aiEmployeeContributionCreateHandler";
import { processPendingDeleteDisablement, processPendingDisablement, startCreateDisablementFlow, startDeleteDisablementFlow } from "./esic/components/disablement/aiDisablementCreateHandler";
import { detectDisablementeIntent } from "./esic/components/disablement/detectDisablementIntent";
import { processPendingDeleteEsicBranch, processPendingEsicBranch, startCreateEsicBranchFlow, startDeleteEsicBranchFlow } from "./esic/components/branch/aiBranchCreateHandler";
import { detectEsicBranchIntent } from "./esic/components/branch/detectBranchIntent";
import { processPendingDeleteEsicReason, processPendingEsicReason, startCreateEsicReasonFlow, startDeleteEsicReasonFlow } from "./esic/components/reason/aiReasonCreateHandler";
import { detectEsicReasonIntent } from "./esic/components/reason/detectReasonIntent";
import { processPendingDeleteEsicBenefit, processPendingEsicBenefit, startCreateEsicBenefitFlow, startDeleteEsicBenefitFlow } from "./esic/components/benefit_type/aiBenefitTypeCreateHandler";
import { detectBenefitTypeIntent } from "./esic/components/benefit_type/detectBenefitTypeIntent";
import { processPendingDeleteEsicConfiguration, processPendingEsicConfiguration, startCreateEsicConfigurationFlow, startDeleteEsicConfigurationFlow } from "./esic/components/configuration/aiConfigurationCreateHandler";
import { detectConfigurationIntent } from "./esic/components/configuration/detectConfigurationIntent";
import { processPendingDeleteEsicEmployee, processPendingEsicEmployee, startCreateEsicEmployeeFlow, startDeleteEsicEmployeeFlow } from "./esic/employee_mapping/aiEmployeeMappingCreateHandler";
import { detectExpenseCategoryIntent } from "./accounting/expense_category/detectExpenseCategoryIntent";
import { processPendingDeleteExpenseCategory, processPendingExpenseCategory, startCreateExpenseCategoryFlow, startDeleteExpenseCategoryFlow } from "./accounting/expense_category/aiExpenseCategoryCreateHandler";
import { detectReimbursementIntent } from "./accounting/reimbursement/detectReimbursementIntent";
import { processPendingDeleteReimbursement, processPendingReimbursement, startCreateReimbursementFlow, startDeleteReimbursementFlow } from "./accounting/reimbursement/aiReimbursementCreateHandler";
import { processPendingBudgetRevenue, processPendingDeleteBudgetRevenue, startCreateBudgetRevenueFlow, startDeleteBudgetRevenueFlow } from "./accounting/budget_revenue/aiBudgetRevenueCreateHandler";
import { detectBudgetRevenueIntent } from "./accounting/budget_revenue/detectBudgetRevenueIntent";
import { processPendingBudgetExpense, processPendingDeleteBudgetExpense, startCreateBudgetExpenseFlow, startDeleteBudgetExpenseFlow } from "./accounting/budget_expense/aiBudgetExpenseCreateHandler";
import { detectBudgetExpenseIntent } from "./accounting/budget_expense/detectBudgetExpenseIntent";
import { processPendingBudget, processPendingDeleteBudget, startCreateBudgetFlow, startDeleteBudgetFlow } from "./accounting/budget/aiBudgetCreateHandler";
import { detectBudgetIntent } from "./accounting/budget/detectBudgetIntent";
import { detectWfhIntent } from "./attendance/work_from_home/detectWfhIntent";
import { processPendingDeleteWorkFromHome, processPendingWorkFromHome, startCreateWorkFromHomeFlow, startDeleteWorkFromHomeFlow } from "./attendance/work_from_home/aiWFHCreateHandler";
import { detectVendorIntent } from "./vendor/detectVendorIntent";
import { processPendingDeleteVendor, processPendingVendor, startCreateVendorFlow, startDeleteVendorFlow } from "./vendor/aiVendorCreateHandler";
import { processPendingDeleteEarning, processPendingEarning, startCreateEarningFlow, startDeleteEarningFlow } from "./payroll/earnings/aiEarningCreateHandler";
import { detectEarningIntent } from "./payroll/earnings/detectEarningIntent";
import { detectOvertimeIntent } from "./payroll/overtime/detectOvertimeIntent";
import { processPendingDeleteOvertime, processPendingOvertime, startCreateOvertimeFlow, startDeleteOvertimeFlow } from "./payroll/overtime/aiOvertimeCreateHandler";
import { processPendingDeduction, processPendingDeleteDeduction, startCreateDeductionFlow, startDeleteDeductionFlow } from "./payroll/deduction/aiDeductionCreateHandler";
import { detectDeductionIntent } from "./payroll/deduction/detectDeductionIntent";
import { detectPayscaleIntent } from "./payroll/payscale/detectPayscaleIntent";
import { processPendingDeletePayscale, processPendingPayscale, startCreatePayscaleFlow, startDeletePayscaleFlow } from "./payroll/payscale/aiPayscaleCreateHandler";
import { processPendingAutoSalary, startCreateAutoSalaryFlow } from "./payroll/Employee_salary/aiEmployeeSalaryCreateHandler";
import { detectAutoSalaryIntent } from "./payroll/Employee_salary/detectEmployeeSalaryIntent";
import { detectEmployeeSalaryStructIntent } from "./payroll/Employee_salary_structure/detectEmployeeSalaryStructIntent";
import { processPendingSalaryStructure, startCreateSalaryStructureFlow } from "./payroll/Employee_salary_structure/aiEmployeeSalaryStructCreateHandler";
import { set } from "react-datepicker/dist/date_utils";
import { detectAssetMaintenanceIntent } from "./Asset/assetMaintainance/detectAssetMaintananceIntent";
import { processPendingAssetMaintenance, processPendingDeleteMaintenance, startCreateAssetMaintenanceFlow, startDeleteMaintenanceFlow } from "./Asset/assetMaintainance/aiAssetMaintainanceCreateHandler";
import { s } from "@fullcalendar/core/internal-common";
import { processPendingDeleteRole, processPendingRole, startCreateRoleFlow, startDeleteRoleFlow } from "./roles/aiRoleCreateHandler";
import { detectRoleIntent } from "./roles/detectRoleIntent";

interface ChatMessage {
    from: "user" | "ai";
    text: string;
}
export enum ReasonType {
    INCLUSION = "Exclusion",
    EXCLUSION = "Termination",
    TERMINATION = "Non-Deduction",
}
const speak = (text: string) => {
    if (!window.speechSynthesis) return;

    const utter = new SpeechSynthesisUtterance(text);
    utter.lang = "en-US";
    utter.rate = 1;      // speed
    utter.pitch = 1;     // tone
    utter.volume = 1;    // volume
    window.speechSynthesis.speak(utter);
};


const AISearchDrawer = () => {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState("");
    const [chat, setChat] = useState<ChatMessage[]>([]);
    const dispatch = useDispatch<AppDispatch>();
    const [pendingDept, setPendingDept] = useState<any | null>(null);
    const [pendingDeleteDept, setPendingDeleteDept] = useState<any | null>(null);
    const [pendingProfile, setPendingProfile] = useState<any | null>(null);
    const [pendingHoliday, setPendingHoliday] = useState<any | null>(null);
    const [pendingDeleteHoliday, setPendingDeleteHoliday] = useState<any | null>(null);
    const [pendingDesignation, setPendingDesignation] = useState<any | null>(null);
    const [pendingDeleteDesignation, setPendingDeleteDesignation] = useState<any | null>(null);
    const [pendingPolicy, setPendingPolicy] = useState<any | null>(null);
    const [pendingDeletePolicy, setPendingDeletePolicy] = useState<any | null>(null);
    const [pendingSkill, setPendingSkill] = useState<any | null>(null);
    const [pendingDeleteSkill, setPendingDeleteSkill] = useState<any | null>(null);
    const [pendingWeeklyOff, setPendingWeeklyOff] = useState<any | null>(null);
    const [pendingDeleteWeeklyOff, setPendingDeleteWeeklyOff] = useState<any | null>(null);
    const { departments } = useSelector((state: any) => state.department);
    const activeDepartments = filterByStatus(departments, 'active', 'Status');
    const { branch } = useSelector((state: any) => state.branch);
    const { employees } = useSelector((state: any) => state.employee);
    const activeEmployee = filterByStatus(employees, 'active', 'employee_status');
    const [aiOptions, setAiOptions] = useState<any[]>([]);
    const [pendingExperience, setPendingExperience] = useState<any | null>(null);
    const [pendingDeleteExperience, setPendingDeleteExperience] = useState<any | null>(null);
    const [pendingTicket, setPendingTicket] = useState<any | null>(null);
    const { TicketsCategories } = useSelector((state: any) => state.ticket.ticketCategory);
    const activeTicketCategory = filterByStatus(TicketsCategories, 'active', 'status');
    const [pendingDeleteTicket, setPendingDeleteTicket] = useState<any | null>(null);
    const [pendingTicketCategory, setPendingTicketCategory] = useState<any | null>(null);
    const [pendingDeleteTicketCategory, setPendingDeleteTicketCategory] = useState<any | null>(null);
    const [pendingTask, setPendingTask] = useState<any | null>(null);
    const [pendingDeleteTask, setPendingDeleteTask] = useState<any | null>(null);
    const [pendingLeaveAdmin, setPendingLeaveAdmin] = useState<any | null>(null);
    const [pendingDeleteLeaveAdmin, setPendingDeleteLeaveAdmin] = useState<any | null>(null);
    const [pendingShiftSchedule, setPendingShiftSchedule] = useState<any | null>(null);
    const [pendingDeleteShiftSchedule, setPendingDeleteShiftSchedule] = useState<any | null>(null);
    const { shiftMasters = [] } = useSelector((state: any) => state.attendance.shift);
    const [pendingFinancialYear, setPendingFinancialYear] = useState<any | null>(null);
    const [pendingUpdateFinancialYear, setPendingUpdateFinancialYear] = useState<any | null>(null);
    const { user } = useSelector((state: any) => state.auth);
    const { activeCompany } = useSelector((state: any) => state.companyDetails);
    const companyId = activeCompany?.company_detail_id
    const [pendingGoalType, setPendingGoalType] = useState<any | null>(null);
    const [pendingDeleteGoalType, setPendingDeleteGoalType] = useState<any | null>(null);
    const [pendingGoal, setPendingGoal] = useState<any>(null);
    const [pendingDeleteGoal, setPendingDeleteGoal] = useState<any>(null);
    const { goal } = useSelector((state: any) => state.performance.goal);
    const goaltype = useSelector((state: any) => state.performance.goaltype.goaltype);
    const [pendingEmployee, setPendingEmployee] = useState<any | null>(null);
    const [pendingUpdateEmployee, setPendingUpdateEmployee] = useState<any | null>(null);
    const [pendingDeleteEmployee, setPendingDeleteEmployee] = useState<any | null>(null);
    const { roles } = useSelector((state: any) => state.role);
    const rolesData = roles ? roles : [];
    const [pendingTraining, setPendingTraining] = useState<any | null>(null);
    const [pendingDeleteTraining, setPendingDeleteTraining] = useState<any | null>(null);
    const { Training } = useSelector((state: any) => state.training.training);
    const trainingType = useSelector((state: any) => state.training.trainingType.trainingtype);
    const { trainer } = useSelector((state: any) => state.training.trainer);
    const [pendingTrainer, setPendingTrainer] = useState<any | null>(null);
    const [pendingDeleteTrainer, setPendingDeleteTrainer] = useState<any | null>(null);
    const [pendingTrainingType, setPendingTrainingType] = useState<any | null>(null);
    const [pendingDeleteTrainingType, setPendingDeleteTrainingType] = useState<any | null>(null);
    const [pendingAssetCategory, setPendingAssetCategory] = useState<any | null>(null);
    const [pendingDeleteAssetCategory, setPendingDeleteAssetCategory] = useState<any | null>(null);
    const { assetCategories } = useSelector((state: any) => state.asset.assetCategory);
    const [pendingAssetRequest, setPendingAssetRequest] = useState<any | null>(null);
    const [pendingDeleteAssetRequest, setPendingDeleteAssetRequest] = useState<any | null>(null);
    const { employeeFullDetails } = useSelector((state: any) => state.employee);
    const employeeId = employeeFullDetails?.employee[0]?.EmployeeID
    const [pendingPromotion, setPendingPromotion] = useState<any | null>(null);
    const [pendingDeletePromotion, setPendingDeletePromotion] = useState<any | null>(null);
    const { designations } = useSelector((state: any) => state.designation);
    const activeDesignations = filterByStatus(designations, 'active', 'DesignationStatus');
    const { payscales } = useSelector((state: any) => state.payroll.payrollScall);
    const [pendingBranch, setPendingBranch] = useState<any | null>(null);
    const [pendingDeleteBranch, setPendingDeleteBranch] = useState<any | null>(null);
    const [pendingTermination, setPendingTermination] = useState<any | null>(null);
    const [pendingDeleteTermination, setPendingDeleteTermination] = useState<any | null>(null);
    const [pendingResignation, setPendingResignation] = useState<any | null>(null);
    const [pendingDeleteResignation, setPendingDeleteResignation] = useState<any | null>(null);
    const getAllHodAndHr = useSelector((state: any) => state.resignation.getAllHodAndHr);
    const [pendingClient, setPendingClient] = useState<any | null>(null);
    const [pendingDeleteClient, setPendingDeleteClient] = useState<any | null>(null);
    const [pendingTaskBoard, setPendingTaskBoard] = useState<any | null>(null);
    const { projectsData } = useSelector((state: any) => state.project.projects);
    const activeProjects = filterByStatus(projectsData, "active", "status");
    const [pendingDeleteTaskBoard, setPendingDeleteTaskBoard] = useState<any | null>(null);
    const [pendingProjectTask, setPendingProjectTask] = useState<any | null>(null);
    const [pendingDeleteProjectTask, setPendingDeleteProjectTask] = useState<any | null>(null);
    const { taskBoards } = useSelector((state: any) => state.project.taskBoard);
    const safeTaskBoards = Array.isArray(taskBoards) ? taskBoards : [];
    const [pendingTimesheet, setPendingTimesheet] = useState<any | null>(null);
    const [pendingDeleteTimesheet, setPendingDeleteTimesheet] = useState<any | null>(null);
    const [pendingEmployeeMapping, setPendingEmployeeMapping] = useState<any | null>(null);
    const [pendingDeleteEmployeeMapping, setPendingDeleteEmployeeMapping] = useState<any | null>(null);
    const pfEnabledEmployees = useMemo(() => { return employees.filter((emp: any) => emp.pfEnable === 1); }, [employees]);
    const activepfEnableEmpl = filterByStatus(pfEnabledEmployees, "active", "employee_status");
    const { records: PfPolicy } = useSelector((state: any) => state.providentFund.pfPolicy);
    const activePfPolicy = filterByStatus(PfPolicy, 'active', 'status');
    const [pendingMonthlyContribution, setPendingMonthlyContribution] = useState<any | null>(null);
    const [pendingDeleteMonthlyContribution, setPendingDeleteMonthlyContribution] = useState<any | null>(null);
    const { earnings = [] } = useSelector((state: any) => state.payroll.earning);
    const [pendingWithdrawalRequest, setPendingWithdrawalRequest] = useState<any | null>(null);
    const [pendingLoanRequest, setPendingLoanRequest] = useState<any | null>(null);
    const [pendingDeleteLoanRequest, setPendingDeleteLoanRequest] = useState<any | null>(null);
    const [pendingPfPolicy, setPendingPfPolicy] = useState<any | null>(null);
    const [pendingDeletePfPolicy, setPendingDeletePfPolicy] = useState<any | null>(null);
    const [pendingTax, setPendingTax] = useState<PendingTax | null>(null);
    const [pendingDeleteTax, setPendingDeleteTax] = useState<PendingDeleteTax | null>(null);
    const { regimes = [] } = useSelector((state: any) => state.TDS.tdsTaxRegime);
    const { financialYearsByCompany } = useSelector((state: any) => state.financialYears);
    const [pendingRegime, setPendingRegime] = useState<any | null>(null);
    const [pendingDeleteRegime, setPendingDeleteRegime] = useState<any | null>(null);
    const [pendingSurcharge, setPendingSurcharge] = useState<any | null>(null);
    const [pendingDeleteSurcharge, setPendingDeleteSurcharge] = useState<any | null>(null);
    const { surchargeCessList } = useSelector((state: any) => state.TDS.tdsSurchargeCess);
    const [autoProcessTds, setAutoProcessTds] = useState<any | null>(null);
    const [pendingDisablement, setPendingDisablement] = useState<any | null>(null);
    const [pendingDeleteDisablement, setPendingDeleteDisablement] = useState<any | null>(null);
    const [pendingEsicBranch, setPendingEsicBranch] = useState<any | null>(null);
    const [pendingDeleteEsicBranch, setPendingDeleteEsicBranch] = useState<any | null>(null);
    const [pendingEsicReason, setPendingEsicReason] = useState<any | null>(null);
    const [pendingDeleteEsicReason, setPendingDeleteEsicReason] = useState<any | null>(null);
    const [pendingEsicBenefit, setPendingEsicBenefit] = useState<any | null>(null);
    const [pendingEsicDeleteBenefit, setPendingEsicDeleteBenefit] = useState<any | null>(null);
    const [pendingEsicConfiguration, setPendingEsicConfiguration] = useState<any | null>(null);
    const [pendingDeleteEsicConfiguration, setPendingDeleteEsicConfiguration] = useState<any | null>(null);
    const [pendingEsicEmployeeMapping, setPendingEsicEmployeeMapping] = useState<any | null>(null);
    const [pendingDeleteEsicEmployeeMapping, setPendingDeleteEsicEmployeeMapping] = useState<any | null>(null);
    const [pendingExpenseCategory, setPendingExpenseCategory] = useState<any | null>(null);
    const [pendingDeleteExpenseCategory, setPendingDeleteExpenseCategory] = useState<any | null>(null);
    const [pendingReimbursement, setPendingReimbursement] = useState<any | null>(null);
    const [pendingDeleteReimbursement, setPendingDeleteReimbursement] = useState<any | null>(null);
    const { uniquePaymentMethods } = useSelector((state: any) => state.accounting.expenses);
    const [pendingBudgetRevenue, setPendingBudgetRevenue] = useState<any | null>(null);
    const [pendingDeleteBudgetRevenue, setPendingDeleteBudgetRevenue] = useState<any | null>(null);
    const { categories } = useSelector((state: any) => state.accounting.expensesCategories);
    const { budgets } = useSelector((state: any) => state.accounting.budget);
    const activeCategories = filterByStatus(categories, "active", "status");
    const activeBudget = filterByStatus(budgets, "active", "status");
    const [pendingBudgetExpense, setPendingBudgetExpense] = useState<any | null>(null);
    const [pendingDeleteBudgetExpense, setPendingDeleteBudgetExpense] = useState<any | null>(null);
    const [pendingBudget, setPendingBudget] = useState<any | null>(null);
    const [pendingDeleteBudget, setPendingDeleteBudget] = useState<any | null>(null);
    const [pendingWFH, setPendingWFH] = useState<any | null>(null);
    const [pendingDeleteWFH, setPendingDeleteWFH] = useState<any | null>(null);
    const [pendingVendor, setPendingVendor] = useState<any | null>(null);
    const [pendingDeleteVendor, setPendingDeleteVendor] = useState<any | null>(null);
    const [pendingEarning, setPendingEarning] = useState<any | null>(null);
    const [pendingDeleteEarning, setPendingDeleteEarning] = useState<any | null>(null);
    const [pendingOvertime, setPendingOvertime] = useState<any | null>(null);
    const [pendingDeleteOvertime, setPendingDeleteOvertime] = useState<any | null>(null);
    const [pendingDeduction, setPendingDeduction] = useState<any | null>(null);
    const [pendingDeleteDeduction, setPendingDeleteDeduction] = useState<any | null>(null);
    const [pendingPayscale, setPendingPayscale] = useState<any | null>(null);
    const [pendingDeletePayscale, setPendingDeletePayscale] = useState<any | null>(null);
    const [pendingEmployeeSalary, setPendingEmployeeSalary] = useState<any | null>(null);
    const [pendingEmployeeSalaryStruct, setPendingEmployeeSalaryStruct] = useState<any | null>(null);
    const { overtimePays } = useSelector((state: any) => state.payroll.overtimRate);
    const { deductions: masterDeductions } = useSelector((state: any) => state.payroll.deduction); // Renamed for clarity
    const [pendingAssetMaintenance, setPendingAssetMaintenance] = useState<any | null>(null);
    const [pendingDeleteAssetMaintenance, setPendingDeleteAssetMaintenance] = useState<any | null>(null);
    const { assets } = useSelector((state: any) => state.asset.newAsset);
    const activeAssets = filterByStatus(assets, 'active', 'status');
    const { maintenances, loadingStates } = useSelector((state: any) => state.asset.assetMaintenance);
    const { assetDetails } = useSelector((state: any) => state.asset.newAsset);
    const usedSerialNumbers = maintenances.map((maintenance: any) => maintenance.asset_details_id);
    const availableSerialNumbers = assetDetails.filter(
        (serial: any) => !usedSerialNumbers.includes(serial.asset_details_id)
    );
    const { clients } = useSelector((state: any) => state.project.clients);
    const vendor: any = clients ? clients.filter((client: any) => client.client_or_vendor === 1) : [];
    const [pendingRole, setPendingRole] = useState<any | null>(null);
    const [pendingDeleteRole, setPendingDeleteRole] = useState<any | null>(null);


    const maintenanceData = [
        { Id: "service", Name: "Service" },
        { Id: "repair", Name: "Repair" },
        { Id: "inspection", Name: "Inspection" },
        { Id: "upgrade", Name: "Upgrade" },
        { Id: "other", Name: "Other" },
    ];
    const maintenanceStatus = [
        { Id : "scheduled", Name: "Scheduled" },
        { Id : "in_progress", Name: "In_Progress" },
        { Id : "completed", Name: "Completed" },
        { Id : "cancelled", Name: "Cancelled" },
        { Id : "paid", Name: "Paid" },
        { Id : "unpaid", Name: "Unpaid" },
    ]





    useEffect(() => {
        if (!PfPolicy.length) {
            dispatch(fetchAllPfPolicies());
        }
        if (!employees.length) {
            dispatch(getEmployees());
        }
    }, [dispatch, PfPolicy.length, employees.length]);


    if (!getAllHodAndHr) dispatch(getAllHODsAndHr());
    const [activeFlow, setActiveFlow] = useState<ActiveFlow>("none");

    const getHodNameById = (hods: any[], hodId: number) =>
        hods?.find((h) => h.EmployeeID === hodId)?.Name || "";

    const getHrNameById = (hrs: any[], hrId: number) =>
        hrs?.find((h) => h.hrId === hrId)?.hrName || "";

    const pushUserChat = (msg: string) =>
        setChat(prev => [...prev, { from: "user", text: msg }]);

    const pushAIChat = (msg: string) => {
        setChat(prev => [...prev, { from: "ai", text: msg }]);

        if (isRecording) {
            speak(msg);
        }
    };

    const [typeSuggestions, setTypeSuggestions] = useState<any[]>([]);
    const [dateSuggestions, setDateSuggestions] = useState<any>(null);
    const [selectedType, setSelectedType] = useState<string | null>(null);
    const [selectedDate, setSelectedDate] = useState<string | null>(null);
    const [aiLoading, setAiLoading] = useState(false);

    const navigate = useNavigate();
    const { suggestions, updateSuggestionsList, searchMenus, loading } = useAISidebarSearch();
    //if edit is not work then the problem in suggestions

    // 🎤 Voice Recognition Setup
    const [isRecording, setIsRecording] = useState(false);
    let recognition: any = null;

    if ("webkitSpeechRecognition" in window) {
        const SpeechRecognition = (window as any).webkitSpeechRecognition;
        recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.interimResults = false;
        recognition.lang = "en-US";

        recognition.onresult = (event: any) => {
            const voiceText = event.results[0][0].transcript;
            setQuery(voiceText); // put text into input
            pushUserChat(voiceText); // add to chat
            const cleaned = voiceText.toLowerCase();
            handleAIFromVoice(cleaned);
        };

        recognition.onerror = (err: any) => {
            setIsRecording(false);
        };

        recognition.onend = () => {
            setIsRecording(false);
        };
    }

    useEffect(() => {
        const handler = () => {
            document.getElementById("ai-global-upload")?.click();
        };
        window.addEventListener("ai-open-file-upload", handler);
        return () => window.removeEventListener("ai-open-file-upload", handler);
    }, []);

    const isFlowAllowed = () => {
        if (activeFlow === "none") return true;

        if (activeFlow === "termination" && pendingTermination) return true;
        if (activeFlow === "shift" && pendingShiftSchedule) return true;
        if (activeFlow === "promotion" && pendingPromotion) return true;
        if (activeFlow === "leave" && pendingLeaveAdmin) return true;
        if (activeFlow === "tax-regime" && pendingRegime) return true;
        if (activeFlow === "tds-slab" && pendingTax) return true;
        if (activeFlow === "tds-surcharge" && pendingSurcharge) return true;

        return false;
    };

    // 🎤 Voice Handler
    const startVoiceInput = () => {
        if (!recognition) {
            message.error("Voice recognition not supported in this browser.");
            return;
        }
        setIsRecording(true);
        recognition.start();
    };

    // When AI should process voice text
    const handleAIFromVoice = (cleaned: string) => {
        if (!isFlowAllowed()) {
            return;
        }
        // AI SMALL TALK
        const smallTalk = getAIChatResponse(cleaned);
        if (smallTalk) {
            pushAIChat(smallTalk);   // already speaks
            return;
        }

        const action = detectAILeaveAction(cleaned);
        if (action) {
            window.dispatchEvent(new CustomEvent("ai-action", { detail: action }));
            speak("Okay, processing your leave request.");   // optional
            return;
        }

        const profileIntent = detectProfileIntent(cleaned);

        if (profileIntent?.intent === "update_photo") {
            startProfileUpdateFlow("photo", setPendingProfile, pushAIChat, speak);
            return;
        }
        if (profileIntent?.intent === "update_name") {
            startProfileUpdateFlow("name", setPendingProfile, pushAIChat, speak);
            return;
        }

        if (profileIntent?.intent === "update_mobile") {
            startProfileUpdateFlow("mobile", setPendingProfile, pushAIChat, speak);
            return;
        }
        if (pendingProfile) {
            processPendingProfileUpdate(cleaned, pendingProfile, setPendingProfile, pushAIChat, speak);
            return;
        }

        const deptIntent = detectDepartmentIntent(cleaned);

        if (deptIntent?.intent === "create_department") {
            startCreateDepartmentFlow(
                setPendingDept,
                pushAIChat,
                speak,
                deptIntent.name
            );
            return;
        }

        if (pendingDept) {
            processPendingDepartment(
                cleaned,
                pendingDept,
                setPendingDept,
                pushAIChat,
                speak
            );
            return;
        }

        const holidayIntent = detectHolidayIntent(cleaned);

        // START CREATE HOLIDAY
        if (holidayIntent?.intent === "create_holiday") {
            startCreateHolidayFlow(
                setPendingHoliday,
                pushAIChat,
                speak,
                holidayIntent.name
            );
            return;
        }

        // CONTINUE HOLIDAY CREATE FLOW (multi-step)
        if (pendingHoliday) {
            processPendingHoliday(
                cleaned,
                pendingHoliday,
                setPendingHoliday,
                pushAIChat,
                speak
            );
            return;
        }

        const designationIntent = detectDesignationIntent(cleaned);

        // START CREATE DESIGNATION
        if (designationIntent?.intent === "create_designation") {
            startCreateDesignationFlow(
                setPendingDesignation,
                pushAIChat,
                speak,
                designationIntent.name
            );
            return;
        }

        // CONTINUE DESIGNATION CREATE FLOW (multi-step)
        if (pendingDesignation) {
            processPendingDesignation(
                cleaned,
                pendingDesignation,
                setPendingDesignation,
                pushAIChat,
                speak
            )
        }

        const policyIntent = detectPolicyIntent(cleaned);

        // START CREATE POLICY
        if (policyIntent?.intent === "create_policy") {
            startCreatePolicyFlow(
                setPendingPolicy,
                pushAIChat,
                speak,
                policyIntent.name
            );
            return;
        }

        // CONTINUE POLICY CREATE FLOW (multi-step)
        if (pendingPolicy) {
            processPendingPolicy(
                cleaned,
                pendingPolicy,
                setPendingPolicy,
                pushAIChat,
                speak
            )
            return;
        }

        const skillIntent = detectSkillIntent(cleaned);

        // START CREATE SKILL
        if (skillIntent?.intent === "create_skill") {
            startCreateSkillFlow(
                setPendingSkill,
                pushAIChat,
                speak,
                skillIntent.name
            );
            return;
        }

        // CONTINUE SKILL CREATE FLOW (multi-step)
        if (pendingSkill) {
            processPendingSkill(
                cleaned,
                pendingSkill,
                setPendingSkill,
                pushAIChat,
                speak
            )
            return;
        }

        const weeklyOffIntent = detectWeeklyOffIntent(cleaned);

        // START CREATE WEEKLYOFF
        if (weeklyOffIntent?.intent === "create_weeklyoff") {
            startCreateWeeklyOffFlow(
                setPendingWeeklyOff,
                pushAIChat,
                speak,
                weeklyOffIntent.name
            );
            return;
        }

        // CONTINUE WEEKLYOFF CREATE FLOW (multi-step)
        if (pendingWeeklyOff) {
            processPendingWeeklyOff(
                cleaned,
                pendingWeeklyOff,
                setPendingWeeklyOff,
                pushAIChat,
                speak
            )
            return;
        }

        const experienceIntent = detectExperienceIntent(cleaned);

        // START CREATE EXPERIENCE
        if (experienceIntent?.intent === "create_experience") {
            startCreateExperienceFlow(
                setPendingExperience,
                pushAIChat,
                speak,
                experienceIntent.name
            );
            return;
        }

        // CONTINUE EXPERIENCE CREATE FLOW (multi-step)
        if (pendingExperience) {
            processPendingExperience(
                cleaned,
                pendingExperience,
                setPendingExperience,
                pushAIChat,
                speak
            )
            return;
        }

        const ticketCategoryIntent = detectTicketCategoryIntent(cleaned);

        // START CREATE TICKET CATEGORY
        if (ticketCategoryIntent?.intent === "create_ticket_category") {
            startCreateTicketCategoryFlow(
                setPendingTicketCategory,
                pushAIChat,
                speak,
                ticketCategoryIntent.name
            );
            return;
        }

        // CONTINUE TICKET CATEGORY CREATE FLOW (multi-step)
        if (pendingTicketCategory) {
            processPendingTicketCategory(
                cleaned,
                pendingTicketCategory,
                setPendingTicketCategory,
                pushAIChat,
                speak
            )
            return;
        }

        const ticketIntent = detectTicketIntent(cleaned);

        // START CREATE TICKET
        if (ticketIntent?.intent === "create_ticket") {
            startCreateTicketFlow(
                setPendingTicket,
                pushAIChat,
                speak,
                ticketIntent.name
            );
            return;
        }

        // CONTINUE TICKET CREATE FLOW (multi-step)
        if (pendingTicket) {
            processPendingTicket(
                cleaned,
                pendingTicket,
                setPendingTicket,
                pushAIChat,
                speak,
                {
                    getCategoryIdByName: (name: string) => {
                        const cat = activeTicketCategory?.find(
                            (c: any) =>
                                c.category_name?.toLowerCase() === name.toLowerCase()
                        );
                        return cat?.ticket_category_id || null;
                    },
                    getDepartmentIdByName: (name: string) => {
                        const dept = activeDepartments?.find(
                            (d: any) =>
                                d.Name?.toLowerCase() === name.toLowerCase()
                        );
                        return dept?.Id || null;
                    },
                    getEmployeeIdByName: (name: string) => {
                        const emp = activeEmployee?.find(
                            (e: any) =>
                                `${e.FirstName} ${e.LastName}`
                                    .toLowerCase()
                                    .includes(name.toLowerCase())
                        );
                        return emp?.EmployeeID || null;
                    }
                }
            );

            return;
        }

        const calendarIntent = detectCalendarIntent(cleaned);

        // START CREATE CALENDAR TASK
        if (calendarIntent?.intent === "create_calendar_task") {
            startCreateTaskFlow(
                setPendingTask,
                pushAIChat,
                speak,
                calendarIntent.name
            );
            return;
        }

        // CONTINUE CALENDAR TASK CREATE FLOW (multi-step)
        if (pendingTask) {
            processPendingTask(
                cleaned,
                pendingTask,
                setPendingTask,
                pushAIChat,
                speak
            )
            return;
        }

        const leaveAdminIntent = detectLeaveAdminIntent(cleaned);

        // START CREATE LEAVE ADMIN
        if (leaveAdminIntent?.intent === "create_leave_admin") {
            setActiveFlow("leave");
            startCreateLeaveAdminFlow(
                setPendingLeaveAdmin,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE LEAVE ADMIN CREATE FLOW (multi-step)
        if (pendingLeaveAdmin) {
            processPendingLeaveAdmin(
                cleaned,
                pendingLeaveAdmin,
                setPendingLeaveAdmin,
                pushAIChat,
                speak
            )
            return;
        }

        const shiftScheduleIntent = detectShiftScheduleIntent(cleaned);

        // START CREATE SHIFT SCHEDULE
        if (shiftScheduleIntent?.intent === "create_shift_schedule") {
            setActiveFlow("shift");
            startCreateShiftScheduleFlow(
                setPendingShiftSchedule,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE SHIFT SCHEDULE CREATE FLOW (multi-step)
        if (pendingShiftSchedule) {
            processPendingShiftSchedule(
                cleaned,
                pendingShiftSchedule,
                setPendingShiftSchedule,
                pushAIChat,
                speak
            )
        }

        const fyIntent = detectFinancialYearIntent(cleaned);

        // CREATE FINANCIAL YEAR
        if (fyIntent?.intent === "create_financial_year") {
            startCreateFinancialYearFlow(
                setPendingFinancialYear,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingFinancialYear) {
            processPendingFinancialYear(
                cleaned,
                pendingFinancialYear,
                setPendingFinancialYear,
                pushAIChat,
                speak,
                companyId
            );
            return;
        }

        // 🟡 UPDATE FINANCIAL YEAR
        if (fyIntent?.intent === "update_financial_year") {
            // you may resolve FY object from redux later
            startUpdateFinancialYearFlow(
                setPendingUpdateFinancialYear,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE UPDATE FLOW
        if (pendingUpdateFinancialYear) {
            processPendingUpdateFinancialYear(
                cleaned,
                pendingUpdateFinancialYear,
                setPendingUpdateFinancialYear,
                pushAIChat,
                speak
            );
            return;
        }

        const goaltypeIntent = detectGoalTypeIntent(cleaned);

        // CREATE GOAL TYPE
        if (goaltypeIntent?.intent === "create_goal_type") {
            startCreateGoalTypeFlow(
                setPendingGoalType,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingGoalType) {
            processPendingGoalType(
                cleaned,
                pendingGoalType,
                setPendingGoalType,
                pushAIChat,
                speak
            )
            return;
        }

        const goalIntent = detectGoalIntent(cleaned);

        // CREATE GOAL
        if (goalIntent?.intent === "create_goal") {
            startCreateGoalFlow(
                setPendingGoal,
                pushAIChat,
                speak,
                goalIntent.name
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingGoal) {
            processPendingGoal(
                cleaned,
                pendingGoal,
                setPendingGoal,
                pushAIChat,
                speak,
                {
                    getGoalTypeIdByName: (name) =>
                        goaltype.find((g: any) =>
                            g.Type.toLowerCase() === name.toLowerCase()
                        )?.Id || null
                }
            )
            return;
        }

        const employeeIntent = detectEmployeeIntent(cleaned);
        //create employee
        if (employeeIntent?.intent === "create_employee") {
            startCreateEmployeeFlow(
                setPendingEmployee,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingEmployee) {
            processPendingEmployee(
                cleaned,
                pendingEmployee,
                setPendingEmployee,
                pushAIChat,
                speak
            );
            return;
        }

        const trainingListIntent = detectTrainingListIntent(cleaned);

        // CREATE TRAINING
        if (trainingListIntent?.intent === "create_training_list") {
            startCreateTrainingFlow(
                setPendingTraining,
                pushAIChat,
                speak,
                trainingListIntent.name
            );
            return;
        }

        // CONTINUE TRAINING CREATE FLOW (multi-step)
        if (pendingTraining) {
            processPendingTraining(
                cleaned,
                pendingTraining,
                setPendingTraining,
                pushAIChat,
                speak,
                {
                    activeEmployee
                }
            );
            return;
        }

        const trainerIntent = detectTrainerIntent(cleaned);

        // CREATE TRAINER
        if (trainerIntent?.intent === "create_trainer") {
            startCreateTrainerFlow(
                setPendingTrainer,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE TRAINER CREATE FLOW (multi-step)
        if (pendingTrainer) {
            processPendingTrainer(
                cleaned,
                pendingTrainer,
                setPendingTrainer,
                pushAIChat,
                speak,
            )
        }

        const trainingTypeIntent = detectTrainingTypeIntent(cleaned);

        // CREATE TRAINING TYPE
        if (trainingTypeIntent?.intent === "create_training_type") {
            startCreateTrainingTypeFlow(
                setPendingTrainingType,
                pushAIChat,
                speak,
                trainingTypeIntent.name
            );
            return;
        }

        // CONTINUE TRAINING TYPE CREATE FLOW (multi-step)
        if (pendingTrainingType) {
            processPendingTrainingType(
                cleaned,
                pendingTrainingType,
                setPendingTrainingType,
                pushAIChat,
                speak
            )
            return;
        }

        const assetCategoriesIntent = detectAssetCategoryIntent(cleaned);

        // CREATE ASSET CATEGORIES
        if (assetCategoriesIntent?.intent === "create_asset_category") {
            startCreateAssetCategoryFlow(
                setPendingAssetCategory,
                pushAIChat,
                speak,
                assetCategoriesIntent.name
            );
            return;
        }

        // CONTINUE ASSET CATEGORIES CREATE FLOW (multi-step)
        if (pendingAssetCategory) {
            processPendingAssetCategory(
                cleaned,
                pendingAssetCategory,
                setPendingAssetCategory,
                pushAIChat,
                speak
            )
            return;
        }

        const promotionIntent = detectPromotionIntent(cleaned);

        // CREATE PROMOTION
        if (promotionIntent?.intent === "create_promotion") {
            setActiveFlow("promotion");
            startCreatePromotionFlow(
                setPendingPromotion,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE PROMOTION CREATE FLOW (multi-step)
        if (pendingPromotion) {
            processPendingPromotion(
                cleaned,
                pendingPromotion,
                setPendingPromotion,
                pushAIChat,
                speak
            )
            return;
        }

        const resignationIntent = detectResignationIntent(cleaned);

        // CREATE RESIGNATION
        if (resignationIntent?.intent === "create_resignation") {
            startCreateResignationFlow(
                setPendingResignation,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE RESIGNATION CREATE FLOW (multi-step)
        if (pendingResignation) {
            processPendingResignation(
                cleaned,
                pendingResignation,
                setPendingResignation,
                pushAIChat,
                speak
            )
            return;
        }

        const branchIntent = detectBranchIntent(cleaned);

        // CREATE BRANCH
        if (branchIntent?.intent === "create_branch") {
            startCreateBranchFlow(
                setPendingBranch,
                pushAIChat,
                speak,
                branchIntent.name
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingBranch) {
            processPendingBranch(
                cleaned,
                pendingBranch,
                setPendingBranch,
                pushAIChat,
                speak
            );
            return;
        }

        // DELETE BRANCH
        if (branchIntent?.intent === "delete_branch") {
            startDeleteBranchFlow(
                setPendingDeleteBranch,
                pushAIChat,
                speak,
                branchIntent.name
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteBranch) {
            processPendingDeleteBranch(
                cleaned,
                pendingDeleteBranch,
                setPendingDeleteBranch,
                pushAIChat,
                speak
            );
            return;
        }

        const terminationIntent = detectTerminationIntent(cleaned);

        // CREATE TERMINATION
        if (terminationIntent?.intent === "create_termination") {
            setActiveFlow("termination");
            startCreateTerminationFlow(
                setPendingTermination,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingTermination) {
            processPendingTermination(
                cleaned,
                pendingTermination,
                setPendingTermination,
                setActiveFlow,
                pushAIChat,
                speak,
            );
            return;
        }

        const clientIntent = detectClientIntent(cleaned);

        // CREATE CLIENT
        if (clientIntent?.intent === "create_client") {
            startCreateClientFlow(
                setPendingClient,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CLIENT CREATE FLOW
        if (pendingClient) {
            processPendingClient(
                cleaned,
                pendingClient,
                setPendingClient,
                pushAIChat,
                speak
            )
        }

        const taskBoardIntent = detectTaskboardIntent(cleaned);

        // CREATE TASK BOARD
        if (taskBoardIntent?.intent === "create_taskboard") {
            startCreateTaskBoardFlow(
                setPendingTaskBoard,
                pushAIChat,
                speak,
                taskBoardIntent.name
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingTaskBoard) {
            processPendingTaskBoard(
                cleaned,
                pendingTaskBoard,
                setPendingTaskBoard,
                pushAIChat,
                speak
            );
            return;
        }

        const projectTaskIntent = detectProjectTaskIntent(cleaned);

        // CREATE PROJECT TASK
        if (projectTaskIntent?.intent === "create_task") {
            startCreateProjectTaskFlow(
                setPendingProjectTask,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingProjectTask) {
            processPendingProjectTask(
                cleaned,
                pendingProjectTask,
                setPendingProjectTask,
                pushAIChat,
                speak
            );
            return;
        }

        const timesheetIntent = detectTimesheetIntent(cleaned);

        // CREATE TIMESHEET
        if (timesheetIntent?.intent === "create_timesheet") {
            startCreateTimesheetFlow(
                setPendingTimesheet,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingTimesheet) {
            processPendingTimesheet(
                cleaned,
                pendingTimesheet,
                setPendingTimesheet,
                pushAIChat,
                speak
            )
            return;
        }

        const esicEmployeeMappingIntent = detectEmployeeMappingIntent(cleaned);

        if (esicEmployeeMappingIntent) {
            if (esicEmployeeMappingIntent.intent === "create_esic_mapping") {
                startCreateEsicEmployeeFlow(
                    setPendingEsicEmployeeMapping,
                    pushAIChat,
                    speak,
                    esicEmployeeMappingIntent.name
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEsicEmployeeMapping) {
            processPendingEsicEmployee(
                cleaned,
                pendingEsicEmployeeMapping,
                setPendingEsicEmployeeMapping,
                pushAIChat,
                speak
            )
            return;
        }

        const emplMapping = detectEmployeeMappingIntent(cleaned);

        // CREATE EMPLOYEE MAPPING
        if (emplMapping?.intent === "create_mapping") {
            startCreateEmployeeMappingFlow(
                setPendingEmployeeMapping,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingEmployeeMapping) {
            processPendingEmployeeMapping(
                cleaned,
                pendingEmployeeMapping,
                setPendingEmployeeMapping,
                pushAIChat,
                speak
            )
            return;
        }

        const withdrawalRequestIntent = detectPfWithdrawalIntent(cleaned);

        // CREATE WITHDRAWAL REQUEST
        if (withdrawalRequestIntent?.intent === "create_withdrawal_request") {
            startCreatePfWithdrawalFlow(
                setPendingWithdrawalRequest,
                pushAIChat,
                speak,
                activepfEnableEmpl[0]?.EmployeeID
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingWithdrawalRequest) {
            processPendingPfWithdrawal(
                cleaned,
                pendingWithdrawalRequest,
                setPendingWithdrawalRequest,
                pushAIChat,
                speak
            )
            return;
        }

        const loanRequestIntent = detectLoanRequestIntent(cleaned);

        // CREATE LOAN REQUEST
        if (loanRequestIntent?.intent === "create_loan_request") {
            startCreatePfLoanFlow(
                setPendingLoanRequest,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingLoanRequest) {
            processPendingPfLoan(
                cleaned,
                pendingLoanRequest,
                setPendingLoanRequest,
                pushAIChat,
                speak
            )
            return;
        }

        const pfPolicyIntent = detectPfPolicyIntent(cleaned);

        // CREATE PF POLICY
        if (pfPolicyIntent?.intent === "create_pf_policy") {
            startCreatePfPolicyFlow(
                setPendingPfPolicy,
                pushAIChat,
                speak,
                pfPolicyIntent.name
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingPfPolicy) {
            processPendingPfPolicy(
                cleaned,
                pendingPfPolicy,
                setPendingPfPolicy,
                pushAIChat,
                speak
            )
            return;
        }

        const tdsIntent = detectTDSlabIntent(cleaned);

        // -------------------------------
        // CREATE TDS SLAB
        // -------------------------------
        if (tdsIntent?.intent === "create_tds_slab") {
            startCreateTaxFlow(
                setPendingTax,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingTax && activeFlow === "tds-slab") {
            processPendingTax(
                cleaned,
                pendingTax,
                setPendingTax,
                pushAIChat,
                speak
            );
            return;
        }

        const taxRegimeIntent = detectTaxRegimeIntent(cleaned);

        // CREATE TAX REGIME
        if (taxRegimeIntent?.intent === "create_tax_regime") {
            startCreateTaxRegimeFlow(
                setPendingRegime,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingRegime && activeFlow === "tax-regime") {
            processPendingTaxRegime(
                cleaned,
                pendingRegime,
                setPendingRegime,
                pushAIChat,
                speak
            )
            return;
        }

        const surchargeChessIntent = detectSurchargeIntent(cleaned);

        // CREATE SURCHARGE CHESS
        if (surchargeChessIntent?.intent === "create_surcharge") {
            startCreateTdsSurchargeCessFlow(
                setPendingSurcharge,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingSurcharge && activeFlow === "tds-surcharge") {
            processPendingTdsSurchargeCess(
                cleaned,
                pendingSurcharge,
                setPendingSurcharge,
                pushAIChat,
                speak
            )
            return;
        }

        const autoProcessTdsIntent = detectEmployeeContributionIntent(cleaned);

        if (autoProcessTdsIntent) {
            if (autoProcessTdsIntent.intent === "create_auto_process_tds") {
                startAutoProcessTdsFlow(
                    setAutoProcessTds,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (autoProcessTds) {
            processPendingAutoTds(
                cleaned,
                autoProcessTds,
                setAutoProcessTds,
                pushAIChat,
                speak,
            )
            return;
        }

        const disablementIntent = detectDisablementeIntent(cleaned);

        if (disablementIntent) {
            if (disablementIntent.intent === "create_disablement") {
                startCreateDisablementFlow(
                    setPendingDisablement,
                    pushAIChat,
                    speak,
                    disablementIntent.name
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingDisablement) {
            processPendingDisablement(
                cleaned,
                pendingDisablement,
                setPendingDisablement,
                pushAIChat,
                speak,
            )
            return;
        }

        const esicBranchIntent = detectEsicBranchIntent(cleaned);

        if (esicBranchIntent) {
            if (esicBranchIntent.intent === "create_esic_branch") {
                startCreateEsicBranchFlow(
                    setPendingEsicBranch,
                    pushAIChat,
                    speak,
                    esicBranchIntent.name
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEsicBranch) {
            processPendingEsicBranch(
                cleaned,
                pendingEsicBranch,
                setPendingEsicBranch,
                pushAIChat,
                speak
            )
            return;
        }

        const esicReasonIntent = detectEsicReasonIntent(cleaned);

        if (esicReasonIntent) {
            if (esicReasonIntent.intent === "create_esic_reason") {
                startCreateEsicReasonFlow(
                    setPendingEsicReason,
                    pushAIChat,
                    speak,
                    esicReasonIntent.name
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEsicReason) {
            processPendingEsicReason(
                cleaned,
                pendingEsicReason,
                setPendingEsicReason,
                pushAIChat,
                speak
            )
            return;
        }

        const esicBenefitIntent = detectBenefitTypeIntent(cleaned);

        if (esicBenefitIntent) {
            if (esicBenefitIntent.intent === "create_benefit_type") {
                startCreateEsicBenefitFlow(
                    setPendingEsicBenefit,
                    pushAIChat,
                    speak,
                    esicBenefitIntent.name
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEsicBenefit) {
            processPendingEsicBenefit(
                cleaned,
                pendingEsicBenefit,
                setPendingEsicBenefit,
                pushAIChat,
                speak
            )
            return;
        }

        const esicConfigurationIntent = detectConfigurationIntent(cleaned);

        if (esicConfigurationIntent) {
            if (esicConfigurationIntent.intent === "create_esic_configuration") {
                startCreateEsicConfigurationFlow(
                    setPendingEsicConfiguration,
                    pushAIChat,
                    speak,
                    esicConfigurationIntent.name
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEsicConfiguration) {
            processPendingEsicConfiguration(
                cleaned,
                pendingEsicConfiguration,
                setPendingEsicConfiguration,
                pushAIChat,
                speak
            )
            return;
        }

        const expenseCategoryIntent = detectExpenseCategoryIntent(cleaned)

        if (expenseCategoryIntent) {
            if (expenseCategoryIntent.intent === "create_expense_category") {
                startCreateExpenseCategoryFlow(
                    setPendingExpenseCategory,
                    pushAIChat,
                    speak,
                    expenseCategoryIntent.name
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingExpenseCategory) {
            processPendingExpenseCategory(
                cleaned,
                pendingExpenseCategory,
                setPendingExpenseCategory,
                pushAIChat,
                speak
            )
            return;
        }

        const reimbursementIntent = detectReimbursementIntent(cleaned);

        if (reimbursementIntent) {
            if (reimbursementIntent.intent === "create_reimbursement") {
                startCreateReimbursementFlow(
                    setPendingReimbursement,
                    pushAIChat,
                    speak,
                    reimbursementIntent.name
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingReimbursement) {
            processPendingReimbursement(
                cleaned,
                pendingReimbursement,
                setPendingReimbursement,
                pushAIChat,
                speak
            )
            return;
        }

        const budgetRevenueIntent = detectBudgetRevenueIntent(cleaned);

        if (budgetRevenueIntent) {
            if (budgetRevenueIntent.intent === "create_budget_revenue") {
                startCreateBudgetRevenueFlow(
                    setPendingBudgetRevenue,
                    pushAIChat,
                    speak,
                    budgetRevenueIntent.name
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingBudgetRevenue) {
            processPendingBudgetRevenue(
                cleaned,
                pendingBudgetRevenue,
                setPendingBudgetRevenue,
                pushAIChat,
                speak
            )
            return;
        }

        const budgetExpenseIntent = detectBudgetExpenseIntent(cleaned);

        if (budgetExpenseIntent) {
            if (budgetExpenseIntent.intent === "create_budget_expense") {
                startCreateBudgetExpenseFlow(
                    setPendingBudgetExpense,
                    pushAIChat,
                    speak,
                    budgetExpenseIntent.name
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingBudgetExpense) {
            processPendingBudgetExpense(
                cleaned,
                pendingBudgetExpense,
                setPendingBudgetExpense,
                pushAIChat,
                speak
            )
            return;
        }

        const budgetIntent = detectBudgetIntent(cleaned);

        if (budgetIntent) {
            if (budgetIntent.intent === "create_budget") {
                startCreateBudgetFlow(
                    setPendingBudget,
                    pushAIChat,
                    speak,
                    budgetIntent.name
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingBudget) {
            processPendingBudget(
                cleaned,
                pendingBudget,
                setPendingBudget,
                pushAIChat,
                speak
            )
            return;
        }

        const wfhIntent = detectWfhIntent(cleaned);

        if (wfhIntent) {
            if (wfhIntent.intent === "create_work_from_home") {
                startCreateWorkFromHomeFlow(
                    setPendingWFH,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingWFH) {
            processPendingWorkFromHome(
                cleaned,
                pendingWFH,
                setPendingWFH,
                pushAIChat,
                speak
            )
            return;
        }

        const vendorIntent = detectVendorIntent(cleaned);

        if (vendorIntent) {
            if (vendorIntent.intent === "create_vendor") {
                startCreateVendorFlow(
                    setPendingVendor,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingVendor) {
            processPendingVendor(
                cleaned,
                pendingVendor,
                setPendingVendor,
                pushAIChat,
                speak
            )
            return;
        }

        const overtimeIntent = detectOvertimeIntent(cleaned);

        if (overtimeIntent) {
            if (overtimeIntent.intent === "create_overtime") {
                startCreateOvertimeFlow(
                    setPendingOvertime,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW 
        if (pendingOvertime) {
            processPendingOvertime(
                cleaned,
                pendingOvertime,
                setPendingOvertime,
                pushAIChat,
                speak
            )
            return;
        }

        const deductionIntent = detectDeductionIntent(cleaned);

        if (deductionIntent) {
            if (deductionIntent.intent === "create_deduction") {
                startCreateDeductionFlow(
                    setPendingDeduction,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingDeduction) {
            processPendingDeduction(
                cleaned,
                pendingDeduction,
                setPendingDeduction,
                pushAIChat,
                speak
            )
            return;
        }

        const payscaleIntent = detectPayscaleIntent(cleaned);

        if (payscaleIntent) {
            if (payscaleIntent.intent === "create_payscale") {
                startCreatePayscaleFlow(
                    setPendingPayscale,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingPayscale) {
            processPendingPayscale(
                cleaned,
                pendingPayscale,
                setPendingPayscale,
                pushAIChat,
                speak
            )
            return;
        }

        const employeeSalary = detectAutoSalaryIntent(cleaned);

        if (employeeSalary) {
            if (employeeSalary.intent === "create_auto_salary") {
                startCreateAutoSalaryFlow(
                    setPendingEmployeeSalary,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEmployeeSalary) {
            processPendingAutoSalary(
                cleaned,
                pendingEmployeeSalary,
                setPendingEmployeeSalary,
                pushAIChat,
                speak
            )
            return;
        }

        const employeeSalaryStruct = detectEmployeeSalaryStructIntent(cleaned);

        if (employeeSalaryStruct) {
            if (employeeSalaryStruct.intent === "create_employee_salary_structure") {
                startCreateSalaryStructureFlow(
                    setPendingEmployeeSalaryStruct,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEmployeeSalaryStruct) {
            processPendingSalaryStructure(
                cleaned,
                pendingEmployeeSalaryStruct,
                setPendingEmployeeSalaryStruct,
                pushAIChat,
                speak
            )
            return;
        }

        const assetMaintenanceIntent = detectAssetMaintenanceIntent(cleaned);

        if (assetMaintenanceIntent) {
            if (assetMaintenanceIntent.intent === "create_asset_maintenance") {
                startCreateAssetMaintenanceFlow(
                    setPendingAssetMaintenance,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingAssetMaintenance) {
            processPendingAssetMaintenance(
                cleaned,
                pendingAssetMaintenance,
                setPendingAssetMaintenance,
                pushAIChat,
                speak
            )
            return;
        }

        const roleIntent = detectRoleIntent(cleaned);

        if (roleIntent) {
            if (roleIntent.intent === "create_role") {
                startCreateRoleFlow(
                    setPendingRole,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingRole) {
            processPendingRole(
                cleaned,
                pendingRole,
                setPendingRole,
                pushAIChat,
                speak
            )
            return;
        }


        const dashboardIntent = detectDashboardIntent(cleaned);
        if (dashboardIntent) {
            if (dashboardIntent.intent === "export_report") {
                speak("Preparing your export file");
                pushAIChat("📦 Preparing your export file...");
                window.dispatchEvent(
                    new CustomEvent("ai-export-trigger", { detail: dashboardIntent })
                );
                return;
            }

            speak("Opening dashboard");
            pushAIChat("📊 Loading dashboard data...");
            navigate("/ai-dashboard", { state: { dashboardIntent } });
            return;
        }


        pushAIChat("😅 I'm still learning! Say it again?");
    };
    const handleAISearch = () => {
        const cleaned = query.trim().toLowerCase();
        if (!isFlowAllowed()) {
            return;
        }
        // 👇 user's text should appear immediately
        pushUserChat(query);
        setQuery("");
        // 1️⃣ SMALL TALK / GREETINGS
        const smallTalk = getAIChatResponse(cleaned);
        if (smallTalk) {
            pushAIChat(smallTalk);
            return;
        }

        // 2️⃣ LEAVE LOGIC
        const action = detectAILeaveAction(cleaned);

        const profileIntent = detectProfileIntent(cleaned);

        if (profileIntent?.intent === "update_photo") {
            startProfileUpdateFlow("photo", setPendingProfile, pushAIChat, speak);
            return;
        }

        if (action) {
            window.dispatchEvent(new CustomEvent("ai-action", { detail: action }));
            return;
        }

        const deptIntent = detectDepartmentIntent(cleaned);

        if (deptIntent?.intent === "create_department") {
            startCreateDepartmentFlow(
                setPendingDept,
                pushAIChat,
                speak,
                deptIntent.name
            );
            return;
        }
        if (pendingDept) {
            processPendingDepartment(
                cleaned,
                pendingDept,
                setPendingDept,
                pushAIChat,
                speak
            );
            return;
        }
        // DELETE department intent
        if (deptIntent?.intent === "delete_department") {

            startDeleteDepartmentFlow(
                setPendingDeleteDept,
                pushAIChat,
                speak,
                deptIntent.name
            );
            return;
        }
        // Continue delete flow
        if (pendingDeleteDept) {
            processPendingDeleteDepartment(
                cleaned,
                pendingDeleteDept,
                setPendingDeleteDept,
                pushAIChat,
                speak
            );
            return;
        }

        // PROFILE INTENT

        // if (profileIntent?.intent === "open_profile") {
        //     pushAIChat("Opening your profile...");
        //     speak("Opening your profile");
        //     navigate("/pages/profile");
        //     return;
        // }
        if (profileIntent?.intent === "update_name") {
            startProfileUpdateFlow("name", setPendingProfile, pushAIChat, speak);
            return;
        }

        if (profileIntent?.intent === "update_mobile") {
            startProfileUpdateFlow("mobile", setPendingProfile, pushAIChat, speak);
            return;
        }

        if (pendingProfile) {
            processPendingProfileUpdate(cleaned, pendingProfile, setPendingProfile, pushAIChat, speak);
            return;
        }

        const holidayIntent = detectHolidayIntent(cleaned);

        // START CREATE HOLIDAY
        if (holidayIntent?.intent === "create_holiday") {
            startCreateHolidayFlow(
                setPendingHoliday,
                pushAIChat,
                speak,
                holidayIntent.name
            );
            return;
        }

        // CONTINUE HOLIDAY CREATE FLOW (multi-step)
        if (pendingHoliday) {
            processPendingHoliday(
                cleaned,
                pendingHoliday,
                setPendingHoliday,
                pushAIChat,
                speak
            );
            return;
        }

        // DELETE HOLIDAY
        if (holidayIntent?.intent === "delete_holiday") {
            startDeleteHolidayFlow(
                setPendingDeleteHoliday,
                pushAIChat,
                speak,
                holidayIntent.name
            );
            return;
        }

        // CONTINUE DELETE HOLIDAY
        if (pendingDeleteHoliday) {
            processPendingDeleteHoliday(
                cleaned,
                pendingDeleteHoliday,
                setPendingDeleteHoliday,
                pushAIChat,
                speak
            );
            return;
        }

        const designationIntent = detectDesignationIntent(cleaned);

        // START CREATE DESIGNATION
        if (designationIntent?.intent === "create_designation") {
            startCreateDesignationFlow(
                setPendingDesignation,
                pushAIChat,
                speak,
                designationIntent.name
            );
            return;
        }

        // CONTINUE DESIGNATION CREATE FLOW (multi-step)
        if (pendingDesignation) {
            processPendingDesignation(
                cleaned,
                pendingDesignation,
                setPendingDesignation,
                pushAIChat,
                speak
            )
            return;
        }

        // DELETE DESIGNATION
        if (designationIntent?.intent === "delete_designation") {
            startDeleteDesignationFlow(
                setPendingDeleteDesignation,
                pushAIChat,
                speak,
                designationIntent.name
            );
            return;
        }

        // CONTINUE DELETE DESIGNATION
        if (pendingDeleteDesignation) {
            processPendingDeleteDesignation(
                cleaned,
                pendingDeleteDesignation,
                setPendingDeleteDesignation,
                pushAIChat,
                speak
            )
            return;
        }

        const policyIntent = detectPolicyIntent(cleaned);

        // START CREATE POLICY
        if (policyIntent?.intent === "create_policy") {
            startCreatePolicyFlow(
                setPendingPolicy,
                pushAIChat,
                speak,
                policyIntent.name
            );
            return;
        }

        // CONTINUE POLICY CREATE FLOW (multi-step)
        if (pendingPolicy) {
            processPendingPolicy(
                cleaned,
                pendingPolicy,
                setPendingPolicy,
                pushAIChat,
                speak
            )
            return;
        }

        // DELETE POLICY
        if (policyIntent?.intent === "delete_policy") {
            startDeletePolicyFlow(
                setPendingDeletePolicy,
                pushAIChat,
                speak,
                policyIntent.name
            );
            return;
        }

        // CONTINUE DELETE POLICY
        if (pendingDeletePolicy) {
            processPendingDeletePolicy(
                cleaned,
                pendingDeletePolicy,
                setPendingDeletePolicy,
                pushAIChat,
                speak
            )
            return;
        }

        const skillIntent = detectSkillIntent(cleaned);

        // START CREATE SKILL
        if (skillIntent?.intent === "create_skill") {
            startCreateSkillFlow(
                setPendingSkill,
                pushAIChat,
                speak,
                skillIntent.name
            );
            return;
        }

        // CONTINUE SKILL CREATE FLOW (multi-step)
        if (pendingSkill) {
            processPendingSkill(
                cleaned,
                pendingSkill,
                setPendingSkill,
                pushAIChat,
                speak
            )
            return;
        }

        // DELETE SKILL
        if (skillIntent?.intent === "delete_skill") {
            startDeleteSkillFlow(
                setPendingDeleteSkill,
                pushAIChat,
                speak,
                skillIntent.name
            );
            return;
        }

        // CONTINUE DELETE SKILL
        if (pendingDeleteSkill) {
            processPendingDeleteSkill(
                cleaned,
                pendingDeleteSkill,
                setPendingDeleteSkill,
                pushAIChat,
                speak
            )
            return;
        }

        const experienceIntent = detectExperienceIntent(cleaned);

        // CREATE EXPERIENCE
        if (experienceIntent?.intent === "create_experience") {
            startCreateExperienceFlow(
                setPendingExperience,
                pushAIChat,
                speak,
                experienceIntent.name
            );
            return;
        }

        // CONTINUE CREATE
        if (pendingExperience) {
            processPendingExperience(
                cleaned,
                pendingExperience,
                setPendingExperience,
                pushAIChat,
                speak
            );
            return;
        }

        // DELETE EXPERIENCE
        if (experienceIntent?.intent === "delete_experience") {
            startDeleteExperienceFlow(
                setPendingDeleteExperience,
                pushAIChat,
                speak,
                experienceIntent.name
            );
            return;
        }

        // CONTINUE DELETE
        if (pendingDeleteExperience) {
            processPendingDeleteExperience(
                cleaned,
                pendingDeleteExperience,
                setPendingDeleteExperience,
                pushAIChat,
                speak
            );
            return;
        }


        const weeklyoffIntent = detectWeeklyOffIntent(cleaned);

        // START CREATE WEEKLYOFF
        if (weeklyoffIntent?.intent === "create_weeklyoff") {
            startCreateWeeklyOffFlow(
                setPendingWeeklyOff,
                pushAIChat,
                speak,
                weeklyoffIntent.name
            );
            return;
        }

        // CONTINUE WEEKLYOFF CREATE FLOW (multi-step)
        if (pendingWeeklyOff) {
            processPendingWeeklyOff(
                cleaned,
                pendingWeeklyOff,
                setPendingWeeklyOff,
                pushAIChat,
                speak
            )
            return;
        }

        // DELETE WEEKLYOFF
        if (weeklyoffIntent?.intent === "delete_weeklyoff") {
            startDeleteWeeklyOffFlow(
                setPendingDeleteWeeklyOff,
                pushAIChat,
                speak,
                weeklyoffIntent.name
            );
            return;
        }

        // CONTINUE DELETE WEEKLYOFF
        if (pendingDeleteWeeklyOff) {
            processPendingDeleteWeeklyOff(
                cleaned,
                pendingDeleteWeeklyOff,
                setPendingDeleteWeeklyOff,
                pushAIChat,
                speak
            )
            return;
        }

        const ticketCategoryIntent = detectTicketCategoryIntent(cleaned);

        // CREATE TICKET CATEGORY
        if (ticketCategoryIntent?.intent === "create_ticket_category") {
            startCreateTicketCategoryFlow(
                setPendingTicketCategory,
                pushAIChat,
                speak,
                ticketCategoryIntent.name
            );
            return;
        }

        if (pendingTicketCategory) {
            processPendingTicketCategory(
                cleaned,
                pendingTicketCategory,
                setPendingTicketCategory,
                pushAIChat,
                speak
            );
            return;
        }

        // DELETE TICKET CATEGORY
        if (ticketCategoryIntent?.intent === "delete_ticket_category") {
            startDeleteTicketCategoryFlow(
                setPendingDeleteTicketCategory,
                pushAIChat,
                speak,
                ticketCategoryIntent.name
            );
            return;
        }

        if (pendingDeleteTicketCategory) {
            processPendingDeleteTicketCategory(
                cleaned,
                pendingDeleteTicketCategory,
                setPendingDeleteTicketCategory,
                pushAIChat,
                speak
            );
            return;
        }

        const ticketIntent = detectTicketIntent(cleaned);

        // START CREATE TICKET
        if (ticketIntent?.intent === "create_ticket") {
            startCreateTicketFlow(
                setPendingTicket,
                pushAIChat,
                speak,
                ticketIntent.name
            );
            return;
        }

        // CONTINUE TICKET FLOW
        if (pendingTicket) {
            processPendingTicket(
                cleaned,
                pendingTicket,
                setPendingTicket,
                pushAIChat,
                speak,
                {
                    getCategoryIdByName: (name: string) => {
                        const cat = TicketsCategories?.find(
                            (c: any) =>
                                c.category_name?.toLowerCase() === name.toLowerCase()
                        );
                        return cat?.ticket_category_id || null;
                    },
                    getDepartmentIdByName: (name: string) => {
                        const dept = activeDepartments?.find(
                            (d: any) =>
                                d.Name?.toLowerCase() === name.toLowerCase()
                        );
                        return dept?.Id || null;
                    },
                    getEmployeeIdByName: (name: string) => {
                        const emp = activeEmployee?.find(
                            (e: any) =>
                                `${e.FirstName} ${e.LastName}`
                                    .toLowerCase()
                                    .includes(name.toLowerCase())
                        );
                        return emp?.EmployeeID || null;
                    }
                }
            );
            return;
        }

        // DELETE TICKET
        if (ticketIntent?.intent === "delete_ticket") {
            startDeleteTicketFlow(
                setPendingDeleteTicket,
                pushAIChat,
                speak,
                ticketIntent.name
            );
            return;
        }

        // CONTINUE DELETE TICKET
        if (pendingDeleteTicket) {
            processPendingDeleteTicket(
                cleaned,
                pendingDeleteTicket,
                setPendingDeleteTicket,
                pushAIChat,
                speak
            )
            return;
        }

        const calendarIntent = detectCalendarIntent(cleaned);

        // START CREATE CALENDAR TASK
        if (calendarIntent?.intent === "create_calendar_task") {
            startCreateTaskFlow(
                setPendingTask,
                pushAIChat,
                speak,
                calendarIntent.name
            );
            return;
        }

        // CONTINUE CALENDAR FLOW
        if (pendingTask) {
            processPendingTask(
                cleaned,
                pendingTask,
                setPendingTask,
                pushAIChat,
                speak
            );
            return;
        }

        // DELETE CALENDAR TASK
        if (calendarIntent?.intent === "delete_calendar_task") {
            startDeleteTaskFlow(
                setPendingDeleteTask,
                pushAIChat,
                speak,
                calendarIntent.name
            );
            return;
        }

        // CONTINUE DELETE CALENDAR TASK
        if (pendingDeleteTask) {
            processPendingDeleteTask(
                cleaned,
                pendingDeleteTask,
                setPendingDeleteTask,
                pushAIChat,
                speak
            );
            return;
        }

        const leaveAdminIntent = detectLeaveAdminIntent(cleaned);

        // CREATE LEAVE
        if (leaveAdminIntent?.intent === "create_leave_admin") {
            setActiveFlow("leave");
            startCreateLeaveAdminFlow(
                setPendingLeaveAdmin,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE
        if (pendingLeaveAdmin) {
            processPendingLeaveAdmin(
                cleaned,
                pendingLeaveAdmin,
                setPendingLeaveAdmin,
                pushAIChat,
                speak
            );
            return;
        }

        // DELETE LEAVE
        if (leaveAdminIntent?.intent === "delete_leave_admin") {
            startDeleteLeaveAdminFlow(
                setPendingDeleteLeaveAdmin,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE DELETE
        if (pendingDeleteLeaveAdmin) {
            processPendingDeleteLeaveAdmin(
                cleaned,
                pendingDeleteLeaveAdmin,
                setPendingDeleteLeaveAdmin,
                pushAIChat,
                speak
            );
            return;
        }

        const shiftScheduleIntent = detectShiftScheduleIntent(cleaned);

        // CREATE SHIFT SCHEDULE
        if (shiftScheduleIntent?.intent === "create_shift_schedule") {
            setActiveFlow("shift");
            startCreateShiftScheduleFlow(
                setPendingShiftSchedule,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE
        if (pendingShiftSchedule) {
            processPendingShiftSchedule(
                cleaned,
                pendingShiftSchedule,
                setPendingShiftSchedule,
                pushAIChat,
                speak
            )
            return;
        }

        // DELETE SHIFT SCHEDULE
        if (shiftScheduleIntent?.intent === "delete_shift_schedule") {
            startDeleteShiftScheduleFlow(
                setPendingDeleteShiftSchedule,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE DELETE
        if (pendingDeleteShiftSchedule) {
            processPendingDeleteShiftSchedule(
                cleaned,
                pendingDeleteShiftSchedule,
                setPendingDeleteShiftSchedule,
                pushAIChat,
                speak
            )
            return;
        }

        const fyIntent = detectFinancialYearIntent(cleaned);

        // CREATE
        if (fyIntent?.intent === "create_financial_year") {
            startCreateFinancialYearFlow(
                setPendingFinancialYear,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE CREATE
        if (pendingFinancialYear) {
            processPendingFinancialYear(
                cleaned,
                pendingFinancialYear,
                setPendingFinancialYear,
                pushAIChat,
                speak,
                companyId
            );
            return;
        }

        // UPDATE
        if (fyIntent?.intent === "update_financial_year") {
            startUpdateFinancialYearFlow(
                setPendingUpdateFinancialYear,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE UPDATE
        if (pendingUpdateFinancialYear) {
            processPendingUpdateFinancialYear(
                cleaned,
                pendingUpdateFinancialYear,
                setPendingUpdateFinancialYear,
                pushAIChat,
                speak
            );
            return;
        }

        const goalTypeIntent = detectGoalTypeIntent(cleaned);

        // CREATE
        if (goalTypeIntent?.intent === "create_goal_type") {
            startCreateGoalTypeFlow(
                setPendingGoalType,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE
        if (pendingGoalType) {
            processPendingGoalType(
                cleaned,
                pendingGoalType,
                setPendingGoalType,
                pushAIChat,
                speak
            )
            return;
        }

        // DELETE
        if (goalTypeIntent?.intent === "delete_goal_type") {
            startDeleteGoalTypeFlow(
                setPendingDeleteGoalType,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE DELETE
        if (pendingDeleteGoalType) {
            processPendingDeleteGoalType(
                cleaned,
                pendingDeleteGoalType,
                setPendingDeleteGoalType,
                pushAIChat,
                speak
            )
            return;
        }

        const goalIntent = detectGoalIntent(cleaned);

        // CREATE
        if (goalIntent?.intent === "create_goal") {
            startCreateGoalFlow(setPendingGoal, pushAIChat, speak, goalIntent.name);
            return;
        }

        if (pendingGoal) {
            processPendingGoal(
                cleaned,
                pendingGoal,
                setPendingGoal,
                pushAIChat,
                speak,
                {
                    getGoalTypeIdByName: (name) =>
                        goaltype.find((g: any) =>
                            g.Type.toLowerCase() === name.toLowerCase()
                        )?.Id || null
                }
            );
            return;
        }

        // DELETE
        if (goalIntent?.intent === "delete_goal") {
            startDeleteGoalFlow(setPendingDeleteGoal, pushAIChat, speak);
            return;
        }

        if (pendingDeleteGoal) {
            processPendingDeleteGoal(
                cleaned,
                pendingDeleteGoal,
                setPendingDeleteGoal,
                pushAIChat,
                speak
            )
            return;
        }

        const employeeIntent = detectEmployeeIntent(cleaned);

        // -------------------------------
        // CREATE EMPLOYEE
        // -------------------------------
        if (employeeIntent?.intent === "create_employee") {
            startCreateEmployeeFlow(
                setPendingEmployee,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingEmployee) {
            processPendingEmployee(
                cleaned,
                pendingEmployee,
                setPendingEmployee,
                pushAIChat,
                speak
            );
            return;
        }

        if (employeeIntent?.intent === "update_employee") {
            startUpdateEmployeeFlow(
                setPendingUpdateEmployee,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE UPDATE FLOW
        if (pendingUpdateEmployee) {
            processPendingUpdateEmployee(
                cleaned,
                pendingUpdateEmployee,
                setPendingUpdateEmployee,
                pushAIChat,
                speak
            );
            return;
        }

        if (employeeIntent?.intent === "delete_employee") {
            startDeleteEmployeeFlow(
                setPendingDeleteEmployee,
                pushAIChat,
                speak,
                employeeIntent.name
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteEmployee) {
            processPendingDeleteEmployee(
                cleaned,
                pendingDeleteEmployee,
                setPendingDeleteEmployee,
                pushAIChat,
                speak
            );
            return;
        }

        const trainingListIntent = detectTrainingListIntent(cleaned);

        // CREATE
        if (trainingListIntent?.intent === "create_training_list") {
            startCreateTrainingFlow(
                setPendingTraining,
                pushAIChat,
                speak,
                trainingListIntent.name
            );
            return;
        }

        if (pendingTraining) {
            processPendingTraining(
                cleaned,
                pendingTraining,
                setPendingTraining,
                pushAIChat,
                speak,
                {
                    activeEmployee
                }
            );
            return;
        }

        // DELETE
        if (trainingListIntent?.intent === "delete_training_list") {
            startDeleteTrainingFlow(
                setPendingDeleteTraining,
                pushAIChat,
                speak,
                trainingListIntent.name
            );
            return;
        }

        if (pendingDeleteTraining) {
            processPendingDeleteTraining(
                cleaned,
                pendingDeleteTraining,
                setPendingDeleteTraining,
                pushAIChat,
                speak
            );
            return;
        }

        const trainerIntent = detectTrainerIntent(cleaned);

        if (trainerIntent?.intent === "create_trainer") {
            startCreateTrainerFlow(
                setPendingTrainer,
                pushAIChat,
                speak,
                trainerIntent.name
            );
            return;
        }

        if (pendingTrainer) {
            processPendingTrainer(
                cleaned,
                pendingTrainer,
                setPendingTrainer,
                pushAIChat,
                speak,
            );
            return;
        }

        if (trainerIntent?.intent === "delete_trainer") {
            startDeleteTrainerFlow(
                setPendingDeleteTrainer,
                pushAIChat,
                speak,
                trainerIntent.name
            );
            return;
        }

        if (pendingDeleteTrainer) {
            processPendingDeleteTrainer(
                cleaned,
                pendingDeleteTrainer,
                setPendingDeleteTrainer,
                pushAIChat,
                speak
            )
            return;
        }

        const trainingTypeIntent = detectTrainingTypeIntent(cleaned);

        // CREATE
        if (trainingTypeIntent?.intent === "create_training_type") {
            startCreateTrainingTypeFlow(
                setPendingTrainingType,
                pushAIChat,
                speak,
                trainingTypeIntent.name
            );
            return;
        }

        if (pendingTrainingType) {
            processPendingTrainingType(
                cleaned,
                pendingTrainingType,
                setPendingTrainingType,
                pushAIChat,
                speak
            )
            return;
        }

        // DELETE
        if (trainingTypeIntent?.intent === "delete_training_type") {
            startDeleteTrainingTypeFlow(
                setPendingDeleteTrainingType,
                pushAIChat,
                speak,
                trainingTypeIntent.name
            );
            return;
        }

        if (pendingDeleteTrainingType) {
            processPendingDeleteTrainingType(
                cleaned,
                pendingDeleteTrainingType,
                setPendingDeleteTrainingType,
                pushAIChat,
                speak
            )
            return;
        }

        const assetCategoriesIntent = detectAssetCategoryIntent(cleaned);

        if (assetCategoriesIntent?.intent === "create_asset_category") {
            startCreateAssetCategoryFlow(
                setPendingAssetCategory,
                pushAIChat,
                speak,
                assetCategoriesIntent.name
            );
            return;
        }

        if (pendingAssetCategory) {
            processPendingAssetCategory(
                cleaned,
                pendingAssetCategory,
                setPendingAssetCategory,
                pushAIChat,
                speak
            )
            return;
        }

        if (assetCategoriesIntent?.intent === "delete_asset_category") {
            startDeleteAssetCategoryFlow(
                setPendingDeleteAssetCategory,
                pushAIChat,
                speak,
                assetCategoriesIntent.name
            );
            return;
        }

        if (pendingDeleteAssetCategory) {
            processPendingDeleteAssetCategory(
                cleaned,
                pendingDeleteAssetCategory,
                setPendingDeleteAssetCategory,
                pushAIChat,
                speak
            )
            return;
        }

        const assetRequestIntent = detectAssetRequestIntent(cleaned);

        if (assetRequestIntent?.intent === "create_asset_request") {
            startCreateAssetRequestFlow(
                setPendingAssetRequest,
                pushAIChat,
                speak,
                assetRequestIntent.name
            );
            return;
        }

        if (pendingAssetRequest) {
            processPendingAssetRequest(
                cleaned,
                pendingAssetRequest,
                setPendingAssetRequest,
                pushAIChat,
                speak,
                employeeId
            )
            return;
        }
        //delete
        if (assetRequestIntent?.intent === "delete_asset_request") {
            startDeleteAssetRequestFlow(
                setPendingDeleteAssetRequest,
                pushAIChat,
                speak,
                assetRequestIntent.name
            );
            return;
        }

        if (pendingDeleteAssetRequest) {
            processPendingDeleteAssetRequest(
                cleaned,
                pendingDeleteAssetRequest,
                setPendingDeleteAssetRequest,
                pushAIChat,
                speak
            )
            return;
        }

        const promotionIntent = detectPromotionIntent(cleaned);

        if (promotionIntent?.intent === "create_promotion") {
            setActiveFlow("promotion");
            startCreatePromotionFlow(
                setPendingPromotion,
                pushAIChat,
                speak,
            );
            return;
        }

        if (pendingPromotion) {
            processPendingPromotion(
                cleaned,
                pendingPromotion,
                setPendingPromotion,
                pushAIChat,
                speak
            )
            return;
        }

        if (promotionIntent?.intent === "delete_promotion") {
            startDeletePromotionFlow(
                setPendingDeletePromotion,
                pushAIChat,
                speak,
                promotionIntent.name
            );
            return;
        }

        if (pendingDeletePromotion) {
            processPendingDeletePromotion(
                cleaned,
                pendingDeletePromotion,
                setPendingDeletePromotion,
                pushAIChat,
                speak
            )
            return;
        }

        const branchIntent = detectBranchIntent(cleaned);

        // CREATE BRANCH
        if (branchIntent?.intent === "create_branch") {
            startCreateBranchFlow(
                setPendingBranch,
                pushAIChat,
                speak,
                branchIntent.name
            );
            return;
        }

        // CONTINUE CREATE
        if (pendingBranch) {
            processPendingBranch(
                cleaned,
                pendingBranch,
                setPendingBranch,
                pushAIChat,
                speak
            );
            return;
        }

        // DELETE BRANCH
        if (branchIntent?.intent === "delete_branch") {
            startDeleteBranchFlow(
                setPendingDeleteBranch,
                pushAIChat,
                speak,
                branchIntent.name
            );
            return;
        }

        // CONTINUE DELETE
        if (pendingDeleteBranch) {
            processPendingDeleteBranch(
                cleaned,
                pendingDeleteBranch,
                setPendingDeleteBranch,
                pushAIChat,
                speak
            );
            return;
        }

        const terminationIntent = detectTerminationIntent(cleaned);

        // CREATE TERMINATION
        if (terminationIntent?.intent === "create_termination") {
            setActiveFlow("termination");
            startCreateTerminationFlow(
                setPendingTermination,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingTermination) {
            processPendingTermination(
                cleaned,
                pendingTermination,
                setPendingTermination,
                setActiveFlow,
                pushAIChat,
                speak
            );
            return;
        }

        // DELETE TERMINATION
        if (terminationIntent?.intent === "delete_termination") {
            startDeleteTerminationFlow(
                setPendingDeleteTermination,
                pushAIChat,
                speak,
                terminationIntent.name
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteTermination) {
            processPendingDeleteTermination(
                cleaned,
                pendingDeleteTermination,
                setPendingDeleteTermination,
                setActiveFlow,
                pushAIChat,
                speak
            );
            return;
        }

        const resignationIntent = detectResignationIntent(cleaned);

        // CREATE RESIGNATION
        if (resignationIntent?.intent === "create_resignation") {
            startCreateResignationFlow(
                setPendingResignation,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingResignation) {
            processPendingResignation(
                cleaned,
                pendingResignation,
                setPendingResignation,
                pushAIChat,
                speak
            )
            return;
        }

        // DELETE RESIGNATION
        if (resignationIntent?.intent === "delete_resignation") {
            startDeleteResignationFlow(
                setPendingDeleteResignation,
                pushAIChat,
                speak,
                resignationIntent.name
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteResignation) {
            processPendingDeleteResignation(
                cleaned,
                pendingDeleteResignation,
                setPendingDeleteResignation,
                pushAIChat,
                speak
            )
            return;
        }

        const clientIntent = detectClientIntent(cleaned);

        // CREATE CLIENT
        if (clientIntent?.intent === "create_client") {
            startCreateClientFlow(
                setPendingClient,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingClient) {
            processPendingClient(
                cleaned,
                pendingClient,
                setPendingClient,
                pushAIChat,
                speak
            );
            return;
        }

        // DELETE CLIENT
        if (clientIntent?.intent === "delete_client") {
            startDeleteClientFlow(
                setPendingDeleteClient,
                pushAIChat,
                speak,
                clientIntent.name
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteClient) {
            processPendingDeleteClient(
                cleaned,
                pendingDeleteClient,
                setPendingDeleteClient,
                pushAIChat,
                speak
            );
            return;
        }

        const taskBoardIntent = detectTaskboardIntent(cleaned);

        // CREATE TASK BOARD
        if (taskBoardIntent?.intent === "create_taskboard") {
            startCreateTaskBoardFlow(
                setPendingTaskBoard,
                pushAIChat,
                speak,
                taskBoardIntent.name
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingTaskBoard) {
            processPendingTaskBoard(
                cleaned,
                pendingTaskBoard,
                setPendingTaskBoard,
                pushAIChat,
                speak
            );
            return;
        }

        // DELETE TASK BOARD
        if (taskBoardIntent?.intent === "delete_taskboard") {
            startDeleteTaskBoardFlow(
                setPendingDeleteTaskBoard,
                pushAIChat,
                speak,
                taskBoardIntent.name
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteTaskBoard) {
            processPendingDeleteTaskBoard(
                cleaned,
                pendingDeleteTaskBoard,
                setPendingDeleteTaskBoard,
                pushAIChat,
                speak
            )
            return;
        }

        const projectTaskIntent = detectProjectTaskIntent(cleaned);

        // CREATE PROJECT TASK
        if (projectTaskIntent?.intent === "create_task") {
            startCreateProjectTaskFlow(
                setPendingProjectTask,
                pushAIChat,
                speak,
                projectTaskIntent.name
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingProjectTask) {
            processPendingProjectTask(
                cleaned,
                pendingProjectTask,
                setPendingProjectTask,
                pushAIChat,
                speak
            );
            return;
        }

        // DELETE PROJECT TASK
        if (projectTaskIntent?.intent === "delete_task") {
            startDeleteProjectTaskFlow(
                setPendingDeleteProjectTask,
                pushAIChat,
                speak,
                projectTaskIntent.name
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteProjectTask) {
            processPendingDeleteProjectTask(
                cleaned,
                pendingDeleteProjectTask,
                setPendingDeleteProjectTask,
                pushAIChat,
                speak
            );
            return;
        }

        const timesheetIntent = detectTimesheetIntent(cleaned);

        // CREATE TIMESHEET
        if (timesheetIntent?.intent === "create_timesheet") {
            startCreateTimesheetFlow(
                setPendingTimesheet,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingTimesheet) {
            processPendingTimesheet(
                cleaned,
                pendingTimesheet,
                setPendingTimesheet,
                pushAIChat,
                speak
            );
            return;
        }

        // DELETE TIMESHEET
        if (timesheetIntent?.intent === "delete_timesheet") {
            startDeleteTimesheetFlow(
                setPendingDeleteTimesheet,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteTimesheet) {
            processPendingDeleteTimesheet(
                cleaned,
                pendingDeleteTimesheet,
                setPendingDeleteTimesheet,
                pushAIChat,
                speak
            );
            return;
        }

        const esicEmployeeMappingIntent = detectEmployeeMappingIntent(cleaned);

        if (esicEmployeeMappingIntent) {
            if (esicEmployeeMappingIntent.intent === "create_esic_mapping") {
                startCreateEsicEmployeeFlow(
                    setPendingEsicEmployeeMapping,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEsicEmployeeMapping) {
            processPendingEsicEmployee(
                cleaned,
                pendingEsicEmployeeMapping,
                setPendingEsicEmployeeMapping,
                pushAIChat,
                speak,
            )
            return;
        }

        if (esicEmployeeMappingIntent) {
            if (esicEmployeeMappingIntent.intent === "delete_esic_mapping") {
                startDeleteEsicEmployeeFlow(
                    setPendingDeleteEsicEmployeeMapping,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteEsicEmployeeMapping) {
            processPendingDeleteEsicEmployee(
                cleaned,
                pendingDeleteEsicEmployeeMapping,
                setPendingDeleteEsicEmployeeMapping,
                pushAIChat,
                speak
            )
            return;
        }

        const emplMappingIntent = detectEmployeeMappingIntent(cleaned);

        // CREATE EMPLOYEE MAPPING
        if (emplMappingIntent?.intent === "create_mapping") {
            startCreateEmployeeMappingFlow(
                setPendingEmployeeMapping,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingEmployeeMapping) {
            processPendingEmployeeMapping(
                cleaned,
                pendingEmployeeMapping,
                setPendingEmployeeMapping,
                pushAIChat,
                speak
            )
            return;
        }

        // DELETE EMPLOYEE MAPPING
        if (emplMappingIntent?.intent === "delete_mapping") {
            startDeleteEmployeeMappingFlow(
                setPendingDeleteEmployeeMapping,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteEmployeeMapping) {
            processPendingDeleteEmployeeMapping(
                cleaned,
                pendingDeleteEmployeeMapping,
                setPendingDeleteEmployeeMapping,
                pushAIChat,
                speak
            )
            return;
        }

        const monthlyContributionIntent = detectEmployeeAutoContributionIntent(cleaned);

        // CREATE MONTHLY CONTRIBUTION
        if (monthlyContributionIntent?.intent === "auto_pf_process") {
            startCreateAutoPfFlow(
                setPendingMonthlyContribution,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingMonthlyContribution) {
            processPendingAutoPf(
                cleaned,
                pendingMonthlyContribution,
                setPendingMonthlyContribution,
                pushAIChat,
                speak
            )
            return;
        }

        const withdrawalRequestIntent = detectPfWithdrawalIntent(cleaned);

        // CREATE WITHDRAWAL REQUEST
        if (withdrawalRequestIntent?.intent === "create_withdrawal_request") {
            startCreatePfWithdrawalFlow(
                setPendingWithdrawalRequest,
                pushAIChat,
                speak,
                activepfEnableEmpl[0]?.EmployeeID
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingWithdrawalRequest) {
            processPendingPfWithdrawal(
                cleaned,
                pendingWithdrawalRequest,
                setPendingWithdrawalRequest,
                pushAIChat,
                speak
            )
            return;
        }

        const loanRequestIntent = detectLoanRequestIntent(cleaned);

        // CREATE LOAN REQUEST
        if (loanRequestIntent?.intent === "create_loan_request") {
            startCreatePfLoanFlow(
                setPendingLoanRequest,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingLoanRequest) {
            processPendingPfLoan(
                cleaned,
                pendingLoanRequest,
                setPendingLoanRequest,
                pushAIChat,
                speak
            )
            return;
        }

        // DELETE LOAN REQUEST
        if (loanRequestIntent?.intent === "delete_loan_request") {
            startDeletePfLoanFlow(
                setPendingDeleteLoanRequest,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteLoanRequest) {
            processPendingDeletePfLoan(
                cleaned,
                pendingDeleteLoanRequest,
                setPendingDeleteLoanRequest,
                pushAIChat,
                speak
            )
            return;
        }

        const pfPolicyIntent = detectPfPolicyIntent(cleaned);

        // CREATE PF POLICY
        if (pfPolicyIntent?.intent === "create_pf_policy") {
            startCreatePfPolicyFlow(
                setPendingPfPolicy,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingPfPolicy) {
            processPendingPfPolicy(
                cleaned,
                pendingPfPolicy,
                setPendingPfPolicy,
                pushAIChat,
                speak
            )
            return;
        }

        // DELETE PF POLICY
        if (pfPolicyIntent?.intent === "delete_pf_policy_setting") {
            startDeletePfPolicyFlow(
                setPendingDeletePfPolicy,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeletePfPolicy) {
            processPendingDeletePfPolicy(
                cleaned,
                pendingDeletePfPolicy,
                setPendingDeletePfPolicy,
                pushAIChat,
                speak
            )
            return;
        }

        const tdsIntent = detectTDSlabIntent(cleaned);

        if (tdsIntent?.intent === "create_tds_slab") {
            startCreateTaxFlow(
                setPendingTax,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingTax) {
            processPendingTax(
                cleaned,
                pendingTax,
                setPendingTax,
                pushAIChat,
                speak
            );
            return;
        }

        if (tdsIntent?.intent === "delete_tds_slab") {
            startDeleteTaxFlow(
                setPendingDeleteTax,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteTax) {
            processPendingDeleteTax(
                cleaned,
                pendingDeleteTax,
                setPendingDeleteTax,
                pushAIChat,
                speak
            );
            return;
        }

        const taxRegimeIntent = detectTaxRegimeIntent(cleaned);

        if (taxRegimeIntent?.intent === "create_tax_regime") {
            startCreateTaxRegimeFlow(
                setPendingRegime,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingRegime) {
            processPendingTaxRegime(
                cleaned,
                pendingRegime,
                setPendingRegime,
                pushAIChat,
                speak
            );
            return;
        }

        if (taxRegimeIntent?.intent === "delete_tax_regime") {
            startDeleteTaxRegimeFlow(
                setPendingDeleteRegime,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteRegime) {
            processPendingDeleteTaxRegime(
                cleaned,
                pendingDeleteRegime,
                setPendingDeleteRegime,
                pushAIChat,
                speak
            )
            return;
        }

        const tdsSurchargeCessIntent = detectSurchargeIntent(cleaned);

        if (tdsSurchargeCessIntent?.intent === "create_surcharge") {
            setPendingTax(null);
            setPendingDeleteTax(null);
            setPendingRegime(null);
            setPendingDeleteRegime(null);

            // 🔒 Lock active flow
            setActiveFlow("tds-surcharge");

            startCreateTdsSurchargeCessFlow(
                setPendingSurcharge,
                pushAIChat,
                speak
            );
            return;
        }

        // CONTINUE CREATE FLOW
        if (pendingSurcharge) {
            processPendingTdsSurchargeCess(
                cleaned,
                pendingSurcharge,
                setPendingSurcharge,
                pushAIChat,
                speak
            )
            return;
        }

        if (tdsSurchargeCessIntent?.intent === "delete_surcharge") {
            startDeleteTdsSurchargeCessFlow(
                setPendingDeleteSurcharge,
                pushAIChat,
                speak,
            );
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteSurcharge) {
            processPendingDeleteTdsSurchargeCess(
                cleaned,
                pendingDeleteSurcharge,
                setPendingDeleteSurcharge,
                pushAIChat,
                speak,
            )
        }

        const autoProcessTdsIntent = detectEmployeeContributionIntent(cleaned);

        if (autoProcessTdsIntent) {
            if (autoProcessTdsIntent.intent === "create_auto_process_tds") {
                startAutoProcessTdsFlow(
                    setAutoProcessTds,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (autoProcessTds) {
            processPendingAutoTds(
                cleaned,
                autoProcessTds,
                setAutoProcessTds,
                pushAIChat,
                speak,
            )
            return;
        }

        const disablementIntent = detectDisablementeIntent(cleaned);

        if (disablementIntent) {
            if (disablementIntent.intent === "create_disablement") {
                startCreateDisablementFlow(
                    setPendingDisablement,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingDisablement) {
            processPendingDisablement(
                cleaned,
                pendingDisablement,
                setPendingDisablement,
                pushAIChat,
                speak,
            )
            return;
        }

        if (disablementIntent) {
            if (disablementIntent.intent === "delete_disablement") {
                startDeleteDisablementFlow(
                    setPendingDeleteDisablement,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteDisablement) {
            processPendingDeleteDisablement(
                cleaned,
                pendingDeleteDisablement,
                setPendingDeleteDisablement,
                pushAIChat,
                speak,
            )
            return;
        }

        const esicBranch = detectEsicBranchIntent(cleaned);

        if (esicBranch) {
            if (esicBranch.intent === "create_esic_branch") {
                startCreateEsicBranchFlow(
                    setPendingEsicBranch,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEsicBranch) {
            processPendingEsicBranch(
                cleaned,
                pendingEsicBranch,
                setPendingEsicBranch,
                pushAIChat,
                speak,
            )
            return;
        }

        if (esicBranch) {
            if (esicBranch.intent === "delete_branch_esic") {
                startDeleteEsicBranchFlow(
                    setPendingDeleteEsicBranch,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteEsicBranch) {
            processPendingDeleteEsicBranch(
                cleaned,
                pendingDeleteEsicBranch,
                setPendingDeleteEsicBranch,
                pushAIChat,
                speak,
            )
            return;
        }

        const esicReason = detectEsicReasonIntent(cleaned);

        if (esicReason) {
            if (esicReason.intent === "create_esic_reason") {
                startCreateEsicReasonFlow(
                    setPendingEsicReason,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEsicReason) {
            processPendingEsicReason(
                cleaned,
                pendingEsicReason,
                setPendingEsicReason,
                pushAIChat,
                speak,
            )
            return;
        }

        if (esicReason) {
            if (esicReason.intent === "delete_esic_reason") {
                startDeleteEsicReasonFlow(
                    setPendingDeleteEsicReason,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteEsicReason) {
            processPendingDeleteEsicReason(
                cleaned,
                pendingDeleteEsicReason,
                setPendingDeleteEsicReason,
                pushAIChat,
                speak
            )
            return;
        }

        const esicBenefitIntent = detectBenefitTypeIntent(cleaned);

        if (esicBenefitIntent) {
            if (esicBenefitIntent.intent === "create_benefit_type") {
                startCreateEsicBenefitFlow(
                    setPendingEsicBenefit,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEsicBenefit) {
            processPendingEsicBenefit(
                cleaned,
                pendingEsicBenefit,
                setPendingEsicBenefit,
                pushAIChat,
                speak,
            )
            return;
        }

        if (esicBenefitIntent) {
            if (esicBenefitIntent.intent === "delete_benefit_type") {
                startDeleteEsicBenefitFlow(
                    setPendingEsicDeleteBenefit,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE DELETE FLOW 
        if (pendingEsicDeleteBenefit) {
            processPendingDeleteEsicBenefit(
                cleaned,
                pendingEsicDeleteBenefit,
                setPendingEsicDeleteBenefit,
                pushAIChat,
                speak,
            )
            return;
        }

        const esicConfigurationIntent = detectConfigurationIntent(cleaned);

        if (esicConfigurationIntent) {
            if (esicConfigurationIntent.intent === "create_esic_configuration") {
                startCreateEsicConfigurationFlow(
                    setPendingEsicConfiguration,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEsicConfiguration) {
            processPendingEsicConfiguration(
                cleaned,
                pendingEsicConfiguration,
                setPendingEsicConfiguration,
                pushAIChat,
                speak
            )
            return;
        }

        if (esicConfigurationIntent) {
            if (esicConfigurationIntent.intent === "delete_esic_configuration") {
                startDeleteEsicConfigurationFlow(
                    setPendingDeleteEsicConfiguration,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteEsicConfiguration) {
            processPendingDeleteEsicConfiguration(
                cleaned,
                pendingDeleteEsicConfiguration,
                setPendingDeleteEsicConfiguration,
                pushAIChat,
                speak
            )
            return;
        }

        const expenseCategoryIntent = detectExpenseCategoryIntent(cleaned);

        if (expenseCategoryIntent) {
            if (expenseCategoryIntent.intent === "create_expense_category") {
                startCreateExpenseCategoryFlow(
                    setPendingExpenseCategory,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingExpenseCategory) {
            processPendingExpenseCategory(
                cleaned,
                pendingExpenseCategory,
                setPendingExpenseCategory,
                pushAIChat,
                speak
            )
            return;
        }

        if (expenseCategoryIntent) {
            if (expenseCategoryIntent.intent === "delete_expense_category") {
                startDeleteExpenseCategoryFlow(
                    setPendingDeleteExpenseCategory,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteExpenseCategory) {
            processPendingDeleteExpenseCategory(
                cleaned,
                pendingDeleteExpenseCategory,
                setPendingDeleteExpenseCategory,
                pushAIChat,
                speak
            )
            return;
        }

        const reimbursementIntent = detectReimbursementIntent(cleaned);

        if (reimbursementIntent) {
            if (reimbursementIntent.intent === "create_reimbursement") {
                startCreateReimbursementFlow(
                    setPendingReimbursement,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingReimbursement) {
            processPendingReimbursement(
                cleaned,
                pendingReimbursement,
                setPendingReimbursement,
                pushAIChat,
                speak,
            )
            return;
        }

        if (reimbursementIntent) {
            if (reimbursementIntent.intent === "delete_reimbursement") {
                startDeleteReimbursementFlow(
                    setPendingDeleteReimbursement,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteReimbursement) {
            processPendingDeleteReimbursement(
                cleaned,
                pendingDeleteReimbursement,
                setPendingDeleteReimbursement,
                pushAIChat,
                speak
            )
            return;
        }

        const budgetRevenueIntent = detectBudgetRevenueIntent(cleaned);

        if (budgetRevenueIntent) {
            if (budgetRevenueIntent.intent === "create_budget_revenue") {
                startCreateBudgetRevenueFlow(
                    setPendingBudgetRevenue,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingBudgetRevenue) {
            processPendingBudgetRevenue(
                cleaned,
                pendingBudgetRevenue,
                setPendingBudgetRevenue,
                pushAIChat,
                speak
            )
            return;
        }

        if (budgetRevenueIntent) {
            if (budgetRevenueIntent.intent === "delete_budget_revenue") {
                startDeleteBudgetRevenueFlow(
                    setPendingDeleteBudgetRevenue,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteBudgetRevenue) {
            processPendingDeleteBudgetRevenue(
                cleaned,
                pendingDeleteBudgetRevenue,
                setPendingDeleteBudgetRevenue,
                pushAIChat,
                speak
            )
            return;
        }

        const budgetExpenseIntent = detectBudgetExpenseIntent(cleaned);

        if (budgetExpenseIntent) {
            if (budgetExpenseIntent.intent === "create_budget_expense") {
                startCreateBudgetExpenseFlow(
                    setPendingBudgetExpense,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingBudgetExpense) {
            processPendingBudgetExpense(
                cleaned,
                pendingBudgetExpense,
                setPendingBudgetExpense,
                pushAIChat,
                speak
            )
            return;
        }

        if (budgetExpenseIntent) {
            if (budgetExpenseIntent.intent === "delete_budget_expense") {
                startDeleteBudgetExpenseFlow(
                    setPendingDeleteBudgetExpense,
                    pushAIChat,
                    speak,
                );
                return;
            }
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteBudgetExpense) {
            processPendingDeleteBudgetExpense(
                cleaned,
                pendingDeleteBudgetExpense,
                setPendingDeleteBudgetExpense,
                pushAIChat,
                speak
            )
            return;
        }

        const budgetIntent = detectBudgetIntent(cleaned);

        if (budgetIntent) {
            if (budgetIntent.intent === "create_budget") {
                startCreateBudgetFlow(
                    setPendingBudget,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingBudget) {
            processPendingBudget(
                cleaned,
                pendingBudget,
                setPendingBudget,
                pushAIChat,
                speak
            )
            return;
        }

        if (budgetIntent) {
            if (budgetIntent.intent === "delete_budget") {
                startDeleteBudgetFlow(
                    setPendingDeleteBudget,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteBudget) {
            processPendingDeleteBudget(
                cleaned,
                pendingDeleteBudget,
                setPendingDeleteBudget,
                pushAIChat,
                speak
            )
            return;
        }

        const wfhIntent = detectWfhIntent(cleaned);

        if (wfhIntent) {
            if (wfhIntent.intent === "create_work_from_home") {
                startCreateWorkFromHomeFlow(
                    setPendingWFH,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingWFH) {
            processPendingWorkFromHome(
                cleaned,
                pendingWFH,
                setPendingWFH,
                pushAIChat,
                speak
            )
            return;
        }

        if (wfhIntent) {
            if (wfhIntent.intent === "delete_work_from_home") {
                startDeleteWorkFromHomeFlow(
                    setPendingDeleteWFH,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteWFH) {
            processPendingDeleteWorkFromHome(
                cleaned,
                pendingDeleteWFH,
                setPendingDeleteWFH,
                pushAIChat,
                speak
            )
            return;
        }

        const vendorIntent = detectVendorIntent(cleaned);

        if (vendorIntent) {
            if (vendorIntent.intent === "create_vendor") {
                startCreateVendorFlow(
                    setPendingVendor,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingVendor) {
            processPendingVendor(
                cleaned,
                pendingVendor,
                setPendingVendor,
                pushAIChat,
                speak
            )
            return;
        }

        if (vendorIntent) {
            if (vendorIntent.intent === "delete_vendor") {
                startDeleteVendorFlow(
                    setPendingDeleteVendor,
                    pushAIChat,
                    speak
                )
            }
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteVendor) {
            processPendingDeleteVendor(
                cleaned,
                pendingDeleteVendor,
                setPendingDeleteVendor,
                pushAIChat,
                speak
            )
            return;
        }

        const earningIntent = detectEarningIntent(cleaned);

        if (earningIntent) {
            if (earningIntent.intent === "create_earning") {
                startCreateEarningFlow(
                    setPendingEarning,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEarning) {
            processPendingEarning(
                cleaned,
                pendingEarning,
                setPendingEarning,
                pushAIChat,
                speak
            )
            return;
        }

        if (earningIntent) {
            if (earningIntent.intent === "delete_earning") {
                startDeleteEarningFlow(
                    setPendingDeleteEarning,
                    pushAIChat,
                    speak
                )
            }
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteEarning) {
            processPendingDeleteEarning(
                cleaned,
                pendingDeleteEarning,
                setPendingDeleteEarning,
                pushAIChat,
                speak
            )
            return;
        }
        const overtimeIntent = detectOvertimeIntent(cleaned);

        if (overtimeIntent) {
            if (overtimeIntent.intent === "create_overtime") {
                startCreateOvertimeFlow(
                    setPendingOvertime,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingOvertime) {
            processPendingOvertime(
                cleaned,
                pendingOvertime,
                setPendingOvertime,
                pushAIChat,
                speak
            )
            return;
        }

        if (overtimeIntent) {
            if (overtimeIntent.intent === "delete_overtime") {
                startDeleteOvertimeFlow(
                    setPendingDeleteOvertime,
                    pushAIChat,
                    speak
                )
            }
            return;
        }

        // CONTINUE DELETE
        if (pendingDeleteOvertime) {
            processPendingDeleteOvertime(
                cleaned,
                pendingDeleteOvertime,
                setPendingDeleteOvertime,
                pushAIChat,
                speak
            );
            return;
        }

        const deductionIntent = detectDeductionIntent(cleaned);

        if (deductionIntent) {
            if (deductionIntent.intent === "create_deduction") {
                startCreateDeductionFlow(
                    setPendingDeduction,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingDeduction) {
            processPendingDeduction(
                cleaned,
                pendingDeduction,
                setPendingDeduction,
                pushAIChat,
                speak
            )
            return;
        }

        if (deductionIntent) {
            if (deductionIntent.intent === "delete_deduction") {
                startDeleteDeductionFlow(
                    setPendingDeleteDeduction,
                    pushAIChat,
                    speak
                )
            }
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteDeduction) {
            processPendingDeleteDeduction(
                cleaned,
                pendingDeleteDeduction,
                setPendingDeleteDeduction,
                pushAIChat,
                speak
            )
        }

        const payscaleIntent = detectPayscaleIntent(cleaned);

        if (payscaleIntent) {
            if (payscaleIntent.intent === "create_payscale") {
                startCreatePayscaleFlow(
                    setPendingPayscale,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingPayscale) {
            processPendingPayscale(
                cleaned,
                pendingPayscale,
                setPendingPayscale,
                pushAIChat,
                speak
            )
            return;
        }

        if (payscaleIntent) {
            if (payscaleIntent.intent === "delete_payscale") {
                startDeletePayscaleFlow(
                    setPendingDeletePayscale,
                    pushAIChat,
                    speak
                )
            }
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeletePayscale) {
            processPendingDeletePayscale(
                cleaned,
                pendingDeletePayscale,
                setPendingDeletePayscale,
                pushAIChat,
                speak
            )
        }

        const employeeSalary = detectAutoSalaryIntent(cleaned);

        if (employeeSalary) {
            if (employeeSalary.intent === "create_auto_salary") {
                startCreateAutoSalaryFlow(
                    setPendingEmployeeSalary,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEmployeeSalary) {
            processPendingAutoSalary(
                cleaned,
                pendingEmployeeSalary,
                setPendingEmployeeSalary,
                pushAIChat,
                speak
            )
            return;
        }

        const employeeSalaryStruct = detectEmployeeSalaryStructIntent(cleaned);

        if (employeeSalaryStruct) {
            if (employeeSalaryStruct.intent === "create_employee_salary_structure") {
                startCreateSalaryStructureFlow(
                    setPendingEmployeeSalaryStruct,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingEmployeeSalaryStruct) {
            processPendingSalaryStructure(
                cleaned,
                pendingEmployeeSalaryStruct,
                setPendingEmployeeSalaryStruct,
                pushAIChat,
                speak
            )
            return;
        }

        const assetMaintainanceIntent = detectAssetMaintenanceIntent(cleaned);

        if (assetMaintainanceIntent) {
            if (assetMaintainanceIntent.intent === "create_asset_maintenance") {
                startCreateAssetMaintenanceFlow(
                    setPendingAssetMaintenance,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingAssetMaintenance) {
            processPendingAssetMaintenance(
                cleaned,
                pendingAssetMaintenance,
                setPendingAssetMaintenance,
                pushAIChat,
                speak
            )
            return;
        }

        if (assetMaintainanceIntent) {
            if (assetMaintainanceIntent.intent === "delete_asset_maintenance") {
                startDeleteMaintenanceFlow(
                    setPendingDeleteAssetMaintenance,
                    pushAIChat,
                    speak
                )
            }
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteAssetMaintenance) {
            processPendingDeleteMaintenance(
                cleaned,
                pendingDeleteAssetMaintenance,
                setPendingDeleteAssetMaintenance,
                pushAIChat,
                speak
            )
            return;
        }

        const roleIntent = detectRoleIntent(cleaned);

        if (roleIntent) {
            if (roleIntent.intent === "create_role") {
                startCreateRoleFlow(
                    setPendingRole,
                    pushAIChat,
                    speak,
                )
                return;
            }
        }

        // CONTINUE CREATE FLOW
        if (pendingRole) {
            processPendingRole(
                cleaned,
                pendingRole,
                setPendingRole,
                pushAIChat,
                speak
            )
            return;
        }

        if (roleIntent) {
            if (roleIntent.intent === "delete_role") {
                startDeleteRoleFlow(
                    setPendingDeleteRole,
                    pushAIChat,
                    speak
                )
            }
            return;
        }

        // CONTINUE DELETE FLOW
        if (pendingDeleteRole) {
            processPendingDeleteRole(
                cleaned,
                pendingDeleteRole,
                setPendingDeleteRole,
                pushAIChat,
                speak
            )
            return;
        }

        const dashboardIntent = detectDashboardIntent(cleaned);

        if (dashboardIntent) {
            if (dashboardIntent.intent === "export_report") {
                window.dispatchEvent(
                    new CustomEvent("ai-export-trigger", { detail: dashboardIntent })
                );
                pushAIChat("📦 Preparing your export file...");
                return;
            }

            pushAIChat("📊 Loading dashboard data...");
            navigate("/ai-dashboard", { state: { dashboardIntent } });
            return;
        }

        // 3️⃣ FUNNY FALLBACK
        pushAIChat("😅 I'm still learning! I don't know this yet — but every day I'm levelling up like a Pokémon!");
    };

    useEffect(() => {
        const startHandler = () => setAiLoading(true);
        const stopHandler = () => setAiLoading(false);

        window.addEventListener("ai-loader-start", startHandler);
        window.addEventListener("ai-loader-stop", stopHandler);

        return () => {
            window.removeEventListener("ai-loader-start", startHandler);
            window.removeEventListener("ai-loader-stop", stopHandler);
        };
    }, []);

    useEffect(() => {
        const handler = (event: any) => {
            const safePushAIChat = (msg: any) => {
                pushAIChat(
                    typeof msg === "string"
                        ? msg
                        : msg?.msg || JSON.stringify(msg)
                );
            };
            safePushAIChat(event.detail);
        };
        window.addEventListener("ai-chat", handler);
        return () => window.removeEventListener("ai-chat", handler);
    }, []);

    useEffect(() => {
        const handler = (event: any) => {
            const { type } = event.detail;

            let suggestions: any[] = [];

            if (type === "branch") {
                suggestions = branch.map((b: any) => ({
                    label: b.Branch_Name,
                    value: b.Id,
                    type: "branch"
                }));
            }

            if (type === "department") {
                suggestions = activeDepartments.map((d: any) => ({
                    label: d.Name,
                    value: d.Id,
                    type: "department"
                }));
            }

            if (type === "employee") {
                suggestions = activeEmployee.map((e: any) => ({
                    label: `${e.FirstName} ${e.LastName}`,
                    value: e.EmployeeId || e.EmployeeID,
                    type: "employee"
                }));
            }
            if (type === "employee-termination") {
                suggestions = activeEmployee.map((e: any) => ({
                    label: `${e.FirstName} ${e.LastName}`,
                    value: e.EmployeeId || e.EmployeeID,
                    type: "employee-termination"
                }));
            }
            if (type === "termination-type") {
                suggestions = Object.entries(Enum.TerminationType).map(
                    ([key, value]) => ({
                        label: value,
                        value: value,
                        type: "termination-type"
                    })
                );
            }
            if (type === "employee-resignation") {
                suggestions = activeEmployee.map((e: any) => ({
                    label: `${e.FirstName} ${e.LastName}`,
                    value: e.EmployeeID,
                    type: "employee-resignation"
                }));
            }
            if (type === "shift") {
                suggestions = shiftMasters.map((s: any) => ({
                    label: `${s.ShiftName} (${s.StartTime} - ${s.EndTime})`,
                    value: String(s.ShiftID),
                    type: "shift"
                }));
            }
            if (type === "role") {
                suggestions = rolesData.map((r: any) => ({
                    label: r.RoleName,
                    value: r.RoleId,
                    type: "role"
                }))
            }
            if (type === "trainingType") {
                suggestions = trainingType.map((t: any) => ({
                    label: t.Name,
                    value: t.Type,
                    type: "trainingType"
                }))
            }
            if (type === "employee_trainer") {
                suggestions = trainer.map((t: any) => ({
                    label: t.Name,
                    value: t.Id || t.EmployeeID,
                    type: "employee_trainer"
                }))
            }
            if (type === "employee_multi") {
                suggestions = activeEmployee.map((e: any) => ({
                    label: `${e.FirstName} ${e.LastName}`,
                    value: e.EmployeeId || e.EmployeeID,
                    type: "employee_multi"
                }));
            }
            if (type === "team-member-project") {
                suggestions = activeEmployee.map((e: any) => ({
                    label: `${e.FirstName} ${e.LastName}`,
                    value: e.EmployeeId || e.EmployeeID,
                    type: "team-member-project"
                }));
            }
            if (type === "asset-category") {
                suggestions = assetCategories.map((c: any) => ({
                    label: c.category_name,
                    value: c.asset_category_id,
                    type: "asset-category"
                }))
            }
            if (type === "employee-promotion") {
                suggestions = activeEmployee.map((e: any) => ({
                    label: `${e.FirstName} ${e.LastName}`,
                    value: e.EmployeeID,
                    type: "employee-promotion"
                }));
            }
            // TASKBOARD
            if (type === "taskboard") {
                suggestions = safeTaskBoards.map((t: any) => ({
                    label: t.Name,
                    value: t.TaskBoardID,
                    type: "taskboard"
                }))
            }
            // DESIGNATION (PROMOTION TO)
            if (type === "designation") {
                suggestions = (activeDesignations || []).map((d: any) => ({
                    label: d.name || d.DesignationName,
                    value: d.Id || d.DesignationId,
                    type: "designation"
                }));
            }
            // MANAGER (EMPLOYEE LIST)
            if (type === "employee_manager") {
                suggestions = activeEmployee.map((e: any) => ({
                    label: `${e.FirstName} ${e.LastName}`,
                    value: e.EmployeeID,
                    type: "employee_manager"
                }));
            }
            if (type === "payscale") {
                suggestions = payscales.map((p: any) => ({
                    label: p.ExperienceLabel,
                    value: p.Id,
                    type: "payscale"
                }))
            }
            if (type === "department-promotion") {
                suggestions = activeDepartments.map((d: any) => ({
                    label: d.Name,
                    value: d.Id,
                    type: "department-promotion"
                }));
            }
            if (type === "project") {
                suggestions = activeProjects.map((p: any) => ({
                    label: p.project_name,
                    value: p.project_id,
                    type: "project"
                }));
            }
            if (type === "timesheet_project") {
                suggestions = activeProjects.map((p: any) => ({
                    label: p.project_name,
                    value: p.project_id,
                    type: "timesheet_project"
                }));
            }
            if (type === "pf-employee") {
                suggestions = activepfEnableEmpl.map((e: any) => ({
                    label: `${e.FirstName} ${e.LastName}`,
                    value: e.EmployeeID,
                    type: "pf-employee"
                }));
            }
            if (type === "pf-policy") {
                suggestions = activePfPolicy.map((p: any) => ({
                    label: p.policyName,
                    value: p.pfPolicyId,
                    type: "pf-policy"
                }));
            }
            if (type === "earning-head-multi") {
                suggestions = earnings.map((e: any) => ({
                    label: e.Name,
                    value: e.Id,
                    type: "earning-head-multi"
                }))
            }
            if (type === "tds-regime") {
                suggestions = regimes.map((r: any) => ({
                    label: r.RegimeName,
                    value: r.TaxRegimeID,
                    type: "tds-regime"
                }))
            }
            if (type === "tds-regime-surcharge") {
                suggestions = regimes.map((r: any) => ({
                    label: r.RegimeName,
                    value: r.TaxRegimeID,
                    type: "tds-regime-surcharge"
                }))
            }
            if (type === "financial-year") {
                suggestions = (financialYearsByCompany || []).map((fy: any) => ({
                    label: fy.name,
                    value: fy.id,
                    type: "financial-year"
                }));
            }
            if (type === "financial-year-surcharge") {
                suggestions = (financialYearsByCompany || []).map((fy: any) => ({
                    label: fy.name,
                    value: fy.id,
                    type: "financial-year-surcharge"
                }));
            }
            if (type === "financial-year-tds") {
                suggestions = (financialYearsByCompany || []).map((fy: any) => ({
                    label: fy.name,
                    value: fy.id,
                    type: "financial-year-tds"
                }));
            }
            if (type === "tax-regime-contri") {
                suggestions = regimes.map((r: any) => ({
                    label: r.RegimeName,
                    value: r.TaxRegimeID,
                    type: "tax-regime-contri"
                }))
            }
            if (type === "surcharge-cess") {
                suggestions = surchargeCessList.map((sc: any) => {
                    const parts = [
                        `Cess ${sc.HealthAndEducationCessRate_Percentage}%`
                    ];

                    if (Number(sc.SurchargeRate1_Percentage) > 0) {
                        parts.push(`S1: ${sc.SurchargeRate1_Percentage}%`);
                    }

                    if (Number(sc.SurchargeRate2_Percentage) > 0) {
                        parts.push(`S2: ${sc.SurchargeRate2_Percentage}%`);
                    }

                    return {
                        label: parts.join(" | "),
                        value: sc.SurchargeCessID,
                        type: "surcharge-cess",
                    };
                });
            }
            if (type === 'earnings-head-contri-tds') {
                suggestions = earnings.map((e: any) => ({
                    label: e.Name,
                    value: e.Id,
                    type: "earnings-head-contri-tds"
                }))
            }
            if (type === "esic-reason-type") {
                suggestions = Object.values(ReasonType).map((r) => ({
                    label: r,
                    value: r,
                    type: "esic-reason-type",
                }));
            }
            if (type === "reimbursement-payment-method") {
                suggestions = uniquePaymentMethods.map((r: any) => ({
                    label: "cash",
                    value: "cash",
                    type: "reimbursement-payment-method",
                }))
            }
            if (type === "budget-revenue-category") {
                suggestions = activeCategories.map((r: any) => ({
                    label: r.category,
                    value: r.expenses_categories_id,
                    type: "budget-revenue-category",
                }))
            }
            if (type === "budget-revenue-budget") {
                suggestions = activeBudget.map((r: any) => ({
                    label: r.budgetTitle,
                    value: r.budget_id,
                    type: "budget-revenue-budget",
                }))
            }
            if (type === "budget-expense-category") {
                suggestions = activeCategories.map((r: any) => ({
                    label: r.category,
                    value: r.expenses_categories_id,
                    type: "budget-expense-category",
                }))
            }
            if (type === "budget-expense-budget") {
                suggestions = activeBudget.map((r: any) => ({
                    label: r.budgetTitle,
                    value: r.budget_id,
                    type: "budget-expense-budget",
                }))
            }
            if (type === "budget-project") {
                suggestions = activeProjects.map((r: any) => ({
                    label: r.project_name,
                    value: r.project_id,
                    type: "budget-project",
                }))
            }
            if (type === "budget-category") {
                suggestions = activeCategories.map((r: any) => ({
                    label: r.category,
                    value: r.expenses_categories_id,
                    type: "budget-category",
                }))
            }
            if (type === "payscale-role") {
                suggestions = rolesData.map((r: any) => ({
                    label: r.RoleName,
                    value: r.RoleId,
                    type: "payscale-role"
                }))
            }
            if (type === "employee-for-structure") {
                suggestions = activeEmployee.map((e: any) => ({
                    label: `${e.FirstName} ${e.LastName}`,
                    value: e.EmployeeId || e.EmployeeID,
                    type: "employee-for-structure"
                }));
            }
            if (type === "payscale-for-salaryStruct") {
                suggestions = payscales.map((p: any) => ({
                    label: `${p.SalaryRangeMin} - ${p.SalaryRangeMax}`,
                    value: p.Id,
                    type: "payscale-for-salaryStruct"
                }));
            }
            if (type === "overtime-pay") {
                suggestions = overtimePays.map((e: any) => ({
                    label: e.Name,
                    value: e.Id,
                    type: "overtime-pay"
                }))
            }
            if (type === "earning-head-multi-for-salaryStruct") {
                suggestions = earnings.map((e: any) => ({
                    label: e.Name,
                    value: e.Id,
                    type: "earning-head-multi"
                }))
            }
            if (type === "deduction-head-multi-for-salaryStruct") {
                suggestions = masterDeductions.map((e: any) => ({
                    label: e.Name,
                    value: e.Id,
                    type: "deduction-head-multi-for-salaryStruct"
                }))
            }
            if (type === "asset-type-name") {
                suggestions = activeAssets.map((c: any) => ({
                    label: c.AssetName,
                    value: c.assetId,
                    type: "asset-type-name"
                }))
            }
            if (type === "asset-serial-by-asset") {
                suggestions = availableSerialNumbers.map((c: any) => ({
                    label: c.SerialNumber,
                    value: c.asset_details_id,
                    type: "asset-serial-by-asset"
                }))
            }
            if (type === "maintenance-type") {
                suggestions = maintenanceData.map((c) => ({
                    label: c.Name,
                    value: c.Id,
                    type: "maintenance-type",
                }));
            }
            if (type === "vendor-list") {
                suggestions = vendor.map((c: any) => ({
                    label: c.first_name + " " + c.last_name,
                    value: c.client_id,
                    type: "vendor-list",
                }))
            }
            if (type === "maintenance-status"){
                suggestions = maintenanceStatus.map((c: any) => ({
                    label: c.Name,
                    value: c.Id,
                    type: "maintenance-status",
                }))
            }



            window.dispatchEvent(
                new CustomEvent("ai-show-suggestions", {
                    detail: suggestions
                })
            );
        };


        window.addEventListener("ai-suggest-options", handler);
        return () => window.removeEventListener("ai-suggest-options", handler);
    }, [branch, activeDepartments, activeEmployee, activeProjects, activePfPolicy]);

    useEffect(() => {
        const handler = (event: any) => {
            const { type, value, label } = event.detail;

            if (type === "employee") {

                if (activeFlow === "leave_admin") {
                    setPendingLeaveAdmin((prev: any) => {
                        if (!prev || prev.employeeId) return prev;
                        return { ...prev, employeeId: value };
                    });

                    pushAIChat("Great! Which leave type should I apply?");
                    speak("Which leave type should I apply?");
                    return;
                }
                if (activeFlow === "shift_schedule") {
                    setPendingShiftSchedule((prev: any) => {
                        if (!prev || prev.employeeIds) return prev;
                        return { ...prev, employeeIds: [value] };
                    });

                    pushAIChat("Which department should this shift be assigned to?");
                    speak("Which department should this shift be assigned to?");
                    return;
                }

                return;
            }
            if (type === "employee-termination") {
                setPendingTermination((prev: any) => ({
                    ...prev,
                    employeeId: value,
                    employeeName: label
                }));

                pushAIChat("What is the termination type?");
                speak("What is the termination type?");
                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "termination-type" }
                    })
                );
                return;
            }
            if (type === "termination-type") {
                setPendingTermination((prev: any) => ({
                    ...prev,
                    step: "noticeDate",
                    terminationType: value
                }));

                pushAIChat("What is the notice date?");
                speak("What is the notice date?");
                return;
            }
            //role
            if (type === "role") {
                setPendingEmployee((prev: any) => {
                    if (!prev || prev.employeeRole) return prev;

                    const updated = { ...prev, employeeRole: value };

                    window.dispatchEvent(
                        new CustomEvent("ai-create-employee", { detail: updated })
                    );

                    return null;
                });

                pushAIChat(`Role "${label}" selected. Creating employee now...`);
                speak(`Role ${label} selected. Creating employee.`);
            }
            //ASSET CATEGORY SELECTED
            if (type === "asset-category") {
                setPendingAssetRequest((prev: any) => {
                    if (!prev || prev.assetCategory) return prev;

                    return {
                        ...prev,
                        assetCategory: label,
                        assetCategoryId: value
                    };
                });

                pushAIChat("How many units do you need?");
                speak("How many units do you need?");
            }
            //training type
            if (type === "trainingType") {
                setPendingTraining((prev: any) => {
                    if (!prev || prev.trainingType) return prev;
                    return {
                        ...prev,
                        trainingType: value
                    };
                });

                pushAIChat("Who is the trainer?");
                speak("Who is the trainer?");
                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "employee_trainer" }
                    })
                );
            }
            //training trainer
            if (type === "employee_trainer") {
                setPendingTraining((prev: any) => {
                    if (!prev || prev.trainer) return prev;
                    return {
                        ...prev,
                        trainer: value
                    };
                });

                pushAIChat("Select attendees for this training.");
                speak("Select attendees for this training.");
                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "employee_multi" }
                    })
                );
            }
            //training employee
            if (type === "employee_multi") {
                setPendingTraining((prev: any) => {
                    if (!prev) return prev;
                    const existing = prev.Attendees || [];
                    if (existing.includes(value)) return prev;
                    return {
                        ...prev,
                        Attendees: [...existing, value]
                    };
                });
            }
            if (type === "team-member-project") {
                setPendingTask((prev: any) => {
                    if (!prev) return prev;
                    const existing = prev.Attendees || [];
                    if (existing.includes(value)) return prev;
                    return {
                        ...prev,
                        Attendees: [...existing, value]
                    };
                });
            }
            // TASK BOARD SELECTED (PROJECT TASK FLOW)
            if (type === "taskboard") {
                setPendingProjectTask((prev: any) => {
                    if (!prev || prev.Status) return prev;

                    return {
                        ...prev,
                        Status: label,
                        StatusLabel: value
                    };
                });

                pushAIChat("What is the task priority? High, Medium, or Low?");
                speak("What is the task priority?");

                return;
            }
            if (type === "employee-promotion") {
                setPendingPromotion((prev: any) => {
                    if (!prev || prev.employeeId) return prev;
                    return {
                        ...prev,
                        employeeId: value
                    };
                });
                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "designation-promotion" }
                    })
                );
            }
            if (type === "designation") {
                setPendingPromotion((prev: any) => {
                    if (!prev || prev.promotionTo) return prev;
                    return {
                        ...prev,
                        promotionTo: value
                    };
                });

                pushAIChat("When should the promotion take place?");
                speak("When should the promotion take place?");

                return;
            }
            if (type === "payscale") {
                setPendingPromotion((prev: any) => {
                    if (!prev || prev.newGrade) return prev;

                    return {
                        ...prev,
                        newGrade: value,
                        newGradeLabel: label
                    };
                });
                pushAIChat("Which is the new department?");
                speak("Which is the new department?");

                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "department-promotion" }
                    })
                );
                return;
            }
            // PROJECT SELECTED (PROJECT TASK FLOW)
            if (type === "project") {
                setPendingProjectTask((prev: any) => {
                    if (!prev) return prev;

                    return {
                        ...prev,
                        ProjectId: value,
                        ProjectLabel: label
                    };
                });

                // MOVE TO NEXT STEP IMMEDIATELY
                pushAIChat("Select team members for this task.");
                speak("Select team members for this task.");

                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "team-member-project" }
                    })
                );

                return;
            }
            if (type === "timesheet_project") {
                setPendingTimesheet((prev: any) => {
                    if (!prev) return prev;

                    return {
                        ...prev,
                        ProjectId: value,
                        ProjectLabel: label
                    };
                })
            }
            if (type === "pf-employee") {
                setPendingEmployeeMapping((prev: any) => {
                    if (!prev || prev.EmployeeID) return prev;
                    return {
                        ...prev,
                        EmployeeID: value,
                        EmployeeName: label
                    };
                });

                pushAIChat("Please select a PF policy.");
                speak("Please select a PF policy.");

                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "pf-policy" }
                    })
                );
                return;
            }
            if (type === "pf-policy") {
                setPendingEmployeeMapping((prev: any) => {
                    if (!prev || prev.pfPolicyId) return prev;
                    return {
                        ...prev,
                        pfPolicyId: value,
                        pfPolicyName: label
                    };
                });

                pushAIChat("Please provide UAN.");
                speak("Please provide UAN.");
                return;
            }
            if (type === "earning-head-multi") {
                setPendingMonthlyContribution((prev: any) => {
                    if (!prev) return prev;

                    const existing = Array.isArray(prev.selected_earning_ids)
                        ? prev.selected_earning_ids
                        : [];

                    if (existing.includes(value)) return prev;

                    return {
                        ...prev,
                        selected_earning_ids: [...existing, value]
                    };
                });

                return;
            }
            if (type === "tds-regime") {
                setPendingTax((prev: any) => {
                    if (!prev || prev.tax_name) return prev;
                    return { ...prev, tax_name: value };
                });

                pushAIChat("What is the effective date? (YYYY-MM-DD)");
                speak("What is the effective date?");
                return;
            }
            if (type === "tds-regime-surcharge") {
                setPendingSurcharge((prev: any) => ({
                    ...prev,
                    TaxRegimeID: value
                }));

                pushAIChat("Enter surcharge rate percentage.");
                speak("Enter surcharge rate percentage.");
                return;
            }
            if (type === "financial-year") {
                setPendingRegime((prev: any) => {
                    if (!prev || prev.FinancialYearID) return prev;
                    return { ...prev, FinancialYearID: value };
                });

                pushAIChat("Is this the default tax regime? Yes or No?");
                speak("Is this the default tax regime?");
                return;
            }
            if (type === "financial-year-surcharge") {
                setPendingSurcharge((prev: any) => ({
                    ...prev,
                    FinancialYearID: value
                }));


                pushAIChat("Please select a tax regime.");
                speak("Please select a tax regime.");

                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "tds-regime-surcharge" }
                    })
                )

                return;
            }
            // check here tds financial year flow and ask for another question in flow
            if (type === "financial-year-tds") {
                setAutoProcessTds((prev: any) => ({
                    ...prev,
                    FinancialYearID: value
                }));

                pushAIChat("Which month should I process TDS for? (YYYY-MM)");
                speak("Which month should I process TDS for?");

                return;
            }
            if (type === "tax-regime-contri") {
                setAutoProcessTds((prev: any) => ({
                    ...prev,
                    TaxRegimeID: value
                }));

                pushAIChat("Which surcharge & cess should be applied?");
                speak("Which surcharge and cess should be applied?");

                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "surcharge-cess" }
                    })
                )
                return;
            }
            if (type === "surcharge-cess") {
                setAutoProcessTds((prev: any) => ({
                    ...prev,
                    SurchargeCessID: value
                }));

                pushAIChat("Which earning heads should be included?");
                speak("Which earning heads should be included?");

                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "earnings-head-contri-tds", multi: true }
                    })
                );
                return;
            }
            if (type === "earnings-head-contri-tds") {
                setAutoProcessTds((prev: any) => {
                    if (!prev) return prev;

                    const existing = Array.isArray(prev.earning_head_ids)
                        ? prev.earning_head_ids
                        : [];

                    if (existing.includes(value)) return prev;

                    return {
                        ...prev,
                        earning_head_ids: [...existing, value]
                    };
                });
                return;
            }
            if (type === "esic-reason-type") {
                setPendingEsicReason((prev: any) => ({
                    ...prev,
                    reason_type: value
                }));

                pushAIChat("Please provide the reason text.");
                speak("Please provide the reason text.");
                return;
            }
            if (type === "reimbursement-payment-method") {
                setPendingReimbursement((prev: any) => {
                    if (!prev) return prev;

                    const updated = { ...prev, payment_method: value };

                    speak("Creating reimbursement.");

                    window.dispatchEvent(
                        new CustomEvent("ai-create-accounting-expense", {
                            detail: updated
                        })
                    );

                    return null;
                });
            }
            if (type === "employee_manager") {
                setPendingPromotion((prev: any) => {
                    if (!prev || prev.newManager) return prev;
                    return {
                        ...prev,
                        newManager: value,
                        newManagerLabel: label
                    };
                });

                // MOVE TO NEXT QUESTION
                pushAIChat("Is the employee relocating? Yes or No?");
                speak("Is the employee relocating?");

                return;
            }
            // EMPLOYEE SELECTED (RESIGNATION)
            if (type === "employee-resignation") {
                setPendingResignation((prev: any) => ({
                    ...prev,
                    employeeId: value,
                    employeeName: label,
                }));

                dispatch(fetchEmployeeDetailsById(value)).then((res: any) => {
                    const data = res?.payload?.data;
                    if (!data) return;

                    const hodName = getHodNameById(getAllHodAndHr?.hods, data.hod_id);
                    const hrName = getHrNameById(getAllHodAndHr?.hrs, data.hrId);


                    setPendingResignation((prev: any) => ({
                        ...prev,
                        department: data.departmentId,
                        departmentLabel: data.DepartmentName,

                        designation: data.designationId,
                        designationLabel: data.DesignationName,

                        manager: data.managerId,
                        managerLabel: data.SupervisorName,

                        hod_id: data.hod_id,
                        hodLabel: hodName,

                        hrId: data.hrId,
                        hrLabel: hrName,
                    }));

                    pushAIChat(
                        `Here are the resignation details:\n
• Department: ${data.DepartmentName}
• Designation: ${data.DesignationName}
• Reporting Manager: ${data.SupervisorName}
• HOD: ${hodName || "Not Assigned"}
• HR: ${hrName || "Not Assigned"}`
                    );

                    speak("Employee details loaded. Please provide the notice date.");
                    pushAIChat("What is the notice date?");
                });

                return;
            }
            if (type === "department-promotion") {
                setPendingPromotion((prev: any) => {
                    if (!prev || prev.newDepartment) return prev;
                    return {
                        ...prev,
                        newDepartment: value,
                        newDepartmentLabel: label
                    };
                });

                // NOW ask for manager
                pushAIChat("Who is the new manager?");
                speak("Who is the new manager?");

                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "employee_manager" }
                    })
                );

                return;
            }
            if (type === "leaveType") {
                setPendingLeaveAdmin((prev: any) => {
                    if (!prev) return prev;
                    return { ...prev, leaveTypeId: value };
                });
                pushAIChat("When should the leave start?");
                speak("When should the leave start?");
            }
            setPendingTraining((prev: any) => {
                if (!prev) return prev;

                if (type === "trainingType") return { ...prev, trainingType: value };
                if (type === "employee_trainer") return { ...prev, trainer: value };
                if (type === "employee_multi") {
                    const existing = prev.Attendees || [];

                    // prevent duplicates
                    if (existing.includes(value)) return prev;

                    return {
                        ...prev,
                        Attendees: [...existing, value]
                    };
                }

                return prev;
            });
            // DEPARTMENT SELECTED
            if (type === "department") {
                if (activeFlow !== "shift") return;
                setPendingShiftSchedule((prev: any) => {
                    if (!prev || prev.departmentId) return prev;
                    return { ...prev, departmentId: value };
                });

                pushAIChat("Which shift should I assign?");
                speak("Which shift should I assign?");

                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "shift" }
                    })
                );
            }
            // SHIFT SELECTED
            if (type === "shift") {
                setPendingShiftSchedule((prev: any) => {
                    if (!prev || prev.shiftId) return prev;
                    return {
                        ...prev,
                        shiftName: event.detail.label,
                        shiftId: value
                    };
                });

                pushAIChat("From which date should the shift start?");
                speak("From which date should the shift start?");
            }
            //PROJECT SELECTED (TASK BOARD)
            if (type === "team-member-project") {
                setPendingProjectTask((prev: any) => {
                    if (!prev) return prev;

                    const existing = Array.isArray(prev.TeamMemberEmployeeId)
                        ? prev.TeamMemberEmployeeId
                        : [];

                    // prevent duplicate
                    if (existing.includes(value)) return prev;

                    return {
                        ...prev,
                        TeamMemberEmployeeId: [...existing, value]
                    };
                });

                return;
            }
            if (type === "budget-revenue-category") {
                setPendingBudgetRevenue((prev: any) => {
                    if (!prev || prev.categoryId) return prev;
                    return {
                        ...prev,
                        categoryId: value
                    };
                });

                pushAIChat("Please select a budget.");
                speak("Please select a budget.");

                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "budget-revenue-budget" }
                    })
                );
                return;
            }
            if (type === "budget-revenue-budget") {
                setPendingBudgetRevenue((prev: any) => {
                    if (!prev || prev.budgetId) return prev;
                    return {
                        ...prev,
                        budgetId: value
                    };
                });

                pushAIChat("What is the amount?");
                speak("What is the amount?");
                return;
            }
            if (type === "budget-expense-category") {
                setPendingBudgetExpense((prev: any) => {
                    if (!prev || prev.categoryId) return prev;
                    return { ...prev, categoryId: value };
                });

                pushAIChat("Please select a budget.");
                speak("Please select a budget.");

                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "budget-expense-budget" }
                    })
                );
                return;
            }
            if (type === "budget-expense-budget") {
                setPendingBudgetExpense((prev: any) => {
                    if (!prev || prev.budgetId) return prev;
                    return { ...prev, budgetId: value };
                });

                pushAIChat("What is the amount?");
                speak("What is the amount?");
                return;
            }
            // Project selection
            if (type === "budget-project") {
                setPendingBudget((prev: any) => ({
                    ...prev,
                    project_id: value
                }));

                pushAIChat("Please provide start date.");
                speak("Please provide start date.");
                return;
            }
            // Category selection
            if (type === "budget-category") {
                setPendingBudget((prev: any) => ({
                    ...prev,
                    category_id: value
                }));

                pushAIChat("Please provide start date.");
                speak("Please provide start date.");
                return;
            }
            if (type === "payscale-role") {
                setPendingPayscale((prev: any) => ({
                    ...prev,
                    role_id: value
                }));
                pushAIChat("What is the minimum salary?");
                speak("What is the minimum salary?");
                return;
            }
            if (type === "employee-for-structure") {
                setPendingEmployeeSalaryStruct((prev: any) => ({
                    ...prev,
                    employee_id: value
                }))
                pushAIChat("Which payscale should I apply?");
                speak("Which payscale should I apply?");
                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "payscale-for-salaryStruct" }
                    })
                )


                return;
            }
            if (type === "payscale-for-salaryStruct") {
                setPendingEmployeeSalaryStruct((prev: any) => ({
                    ...prev,
                    payscale_id: value
                }))
                pushAIChat("Do you want to apply overtime pay?");
                speak("Do you want to apply overtime pay?");

                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "overtime-pay" }
                    })
                );
                return;
            }
            if (type === "overtime-pay") {
                setPendingEmployeeSalaryStruct((prev: any) => ({
                    ...prev,
                    overtime_pay_id: value
                }));

                pushAIChat("Select earning heads.");
                speak("Select earning heads.");

                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "earning-head-multi-for-salaryStruct", multi: true }
                    })
                );
                return;
            }
            if (type === "earning-head-multi-for-salaryStruct") {
                setPendingEmployeeSalaryStruct((prev: any) => ({
                    ...prev,
                    earning_head_ids: value
                }))
                pushAIChat("Select deduction heads.");
                speak("Select deduction heads.");

                window.dispatchEvent(
                    new CustomEvent("ai-suggest-options", {
                        detail: { type: "deduction-head-multi-for-salaryStruct", multi: true }
                    })
                );
                return;
            }
            if (type === "deduction-head-multi-for-salaryStruct") {
                setPendingEmployeeSalaryStruct((prev: any) => ({
                    ...prev,
                    deduction_head_ids: value
                }))
                pushAIChat("Please provide start date.");
                speak("Please provide start date.");
                return;
            }
            if (type === "asset-type-name") {
                setPendingAssetMaintenance((prev: any) => ({ ...prev, asset_id: value }));
            }

            if (type === "asset-serial-by-asset") {
                setPendingAssetMaintenance((prev: any) => ({ ...prev, asset_details_id: value }));
            }

            if (type === "maintenance-type") {
                setPendingAssetMaintenance((prev: any) => ({ ...prev, maintenance_type: value }));
            }

            if (type === "vendor-list") {
                setPendingAssetMaintenance((prev: any) => ({ ...prev, vendor: value }));
            }

            if (type === "maintenance-status") {
                setPendingAssetMaintenance((prev: any) => ({ ...prev, status: value }));
            }



            setPendingWeeklyOff((prev: any) => {
                if (!prev) return prev;

                return {
                    ...prev,
                    selectedTypeId: [value]
                };
            });

        };

        window.addEventListener("ai-option-selected", handler);
        return () => window.removeEventListener("ai-option-selected", handler);
    }, []);

    useEffect(() => {
        const handler = (event: any) => {
            setAiOptions(event.detail || []);
        };

        window.addEventListener("ai-show-suggestions", handler);
        return () => window.removeEventListener("ai-show-suggestions", handler);
    }, []);

    useEffect(() => {
        const handler = (event: any) => {
            setTypeSuggestions(event.detail || []);
        };
        window.addEventListener("ai-suggest-types", handler);
        return () => window.removeEventListener("ai-suggest-types", handler);
    }, []);

    useEffect(() => {
        const handler = (event: any) => {
            setDateSuggestions(event.detail);
        };
        window.addEventListener("ai-suggest-dates", handler);
        return () => window.removeEventListener("ai-suggest-dates", handler);
    }, []);

    // Open drawer via global event (Cmd+K / Ctrl+K style)
    useEffect(() => {
        const handler = () => {
            setOpen(true);
            setQuery("");
            updateSuggestionsList("");
        };
        window.addEventListener("open-ai-search", handler);
        return () => window.removeEventListener("open-ai-search", handler);
    }, [updateSuggestionsList]);



    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleAISearch();
        }
    };

    // Unicode sparkle for the AI magic ✨ (or use an AntD icon below)
    const SparkleIcon = () => <span style={{ fontSize: "inherit" }}>✨</span>;

    return (
        <Drawer
            style={{ marginTop: 50, paddingBottom: 50 }}
            title={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <SparkleIcon />
                    <strong>Leadchain AI</strong>
                </div>
            }
            placement="right"
            width={420}
            open={open}
            onClose={() => setOpen(false)}
            closeIcon={null}
            styles={{
                body: { padding: 0, display: "flex", flexDirection: "column", height: "100%" },
                header: { borderBottom: "1px solid #f0f0f0", padding: "12px 20px" },
            }}
        >
            {/* Suggestions Area - Chat Style */}
            {/* Chat + Suggestions Area */}
            <div
                style={{
                    flex: 1,
                    overflowY: "auto",
                    padding: "20px",
                    background: "#fafafa",
                    display: "flex",
                    flexDirection: "column",
                    gap: 12,
                }}
            >
                {/* AI CHAT MESSAGES */}
                {chat?.map((msg, index) => (
                    <div
                        key={index}
                        style={{
                            display: "flex",
                            justifyContent: msg.from === "user" ? "flex-end" : "flex-start"
                        }}
                    >
                        <div
                            style={{
                                padding: "10px 14px",
                                background: msg.from === "user" ? "#722ed1" : "#eee",
                                color: msg.from === "user" ? "white" : "black",
                                borderRadius: 12,
                                maxWidth: "75%",
                            }}
                        >
                            {typeof msg.text === "string"
                                ? msg.text
                                : JSON.stringify(msg.text)}
                        </div>
                    </div>
                ))}

                {/* AI SEARCH SUGGESTIONS */}
                {loading ? (
                    <div style={{ textAlign: "center", padding: "40px 0" }}>
                        <Spin size="large" />
                    </div>
                ) : suggestions.length === 0 && query ? (
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                            <span style={{ color: "#999" }}>
                                No results for "<i>{query}</i>"
                            </span>
                        }
                    />
                ) : suggestions.length === 0 ? (
                    <div style={{ textAlign: "center", marginTop: 60, color: "#999" }}>
                        Ask me anything — Payroll, Attendance, Leave…
                    </div>
                ) : (
                    suggestions.map((item: any, index: number) => (
                        <div
                            key={index}
                            onClick={() => {
                                navigate(item.link);
                                setOpen(false);
                            }}
                            style={{
                                padding: "14px",
                                background: "white",
                                borderRadius: 12,
                                cursor: "pointer",
                                border: "1px solid #eee",
                            }}
                        >
                            <b>{item.label}</b>
                        </div>
                    ))
                )}

                {/* Leave Type Suggestions */}
                {typeSuggestions.length > 0 && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                        {typeSuggestions.map((l: any, idx: number) => (
                            <div
                                key={idx}
                                onClick={() => {
                                    setTypeSuggestions([]);
                                    setSelectedType(l.LeaveTypeName);

                                    const newQuery = selectedDate
                                        ? `apply ${l.LeaveTypeName.toLowerCase()} leave on ${selectedDate}`
                                        : `apply ${l.LeaveTypeName.toLowerCase()}`;

                                    setQuery(newQuery);
                                }}

                                style={{
                                    padding: "6px 12px",
                                    background: "#e6f4ff",
                                    borderRadius: 20,
                                    cursor: "pointer",
                                    border: "1px solid #91caff",
                                    fontSize: 13
                                }}
                            >
                                {l.LeaveTypeName}
                            </div>
                        ))}
                    </div>
                )}
                {/* leave admin suggestion leave */}
                {/* Leave Type Suggestions (LEAVE ADMIN FLOW) */}
                {typeSuggestions.length > 0 && (
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 8,
                            marginTop: 10
                        }}
                    >
                        {typeSuggestions.map((l: any, idx: number) => (
                            <div
                                key={idx}
                                onClick={() => {
                                    // Hide suggestions
                                    setTypeSuggestions([]);

                                    // Set Leave Type ID into pending state
                                    setPendingLeaveAdmin((prev: any) => {
                                        if (!prev) return prev;

                                        return {
                                            ...prev,
                                            leaveTypeId: l.LeaveTypeId
                                        };
                                    });

                                    // Move flow forward
                                    pushAIChat("When should the leave start?");
                                    speak("When should the leave start?");
                                }}
                                style={{
                                    padding: "6px 14px",
                                    background: "#e6f4ff",
                                    borderRadius: 20,
                                    cursor: "pointer",
                                    border: "1px solid #91caff",
                                    fontSize: 13,
                                    fontWeight: 500
                                }}
                            >
                                {l.LeaveTypeName}
                            </div>
                        ))}
                    </div>
                )}
                {/* Date Suggestions */}
                {dateSuggestions && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 10 }}>
                        {Object.entries(dateSuggestions).map(([key, date], index) => (
                            <div
                                key={index}
                                onClick={() => {
                                    const prettyDate = dayjs(date as string).format("DD MMM");

                                    setSelectedDate(prettyDate);
                                    setDateSuggestions(null);

                                    // Merge leave type + date
                                    const newQuery = selectedType
                                        ? `apply ${selectedType.toLowerCase()} on ${prettyDate}`
                                        : `apply leave on ${prettyDate}`;

                                    setQuery(newQuery);
                                }}

                                style={{
                                    padding: "6px 12px",
                                    background: "#fff7e6",
                                    borderRadius: 20,
                                    cursor: "pointer",
                                    border: "1px solid #ffd591",
                                    fontSize: 13
                                }}
                            >
                                {key === "today" && "Today"}
                                {key === "tomorrow" && "Tomorrow"}
                                {key === "dayAfter" && "Day After Tomorrow"}
                                {key === "nextWeek" && "Next Week"}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {aiOptions.length > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                    {aiOptions.map((opt, idx) => (
                        <div
                            key={idx}
                            onClick={() => {
                                setAiOptions([]);

                                window.dispatchEvent(
                                    new CustomEvent("ai-option-selected", {
                                        detail: opt
                                    })
                                );
                            }}
                            style={{
                                padding: "6px 12px",
                                background: "#e6f4ff",
                                borderRadius: 20,
                                cursor: "pointer",
                                border: "1px solid #91caff",
                                fontSize: 13
                            }}
                        >
                            {typeof opt.label === "string"
                                ? opt.label
                                : opt.label?.msg || "Select option"}
                        </div>
                    ))}
                </div>
            )}
            {/* Search Input Bar */}
            <div
                style={{
                    padding: "16px 20px",
                    borderTop: "1px solid #f0f0f0",
                    background: "white",
                    boxShadow: "0 -4px 12px rgba(0,0,0,0.05)",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        background: "#f5f5f5",
                        borderRadius: 12,
                        padding: "12px 16px",
                        border: "1px solid #e8e8e8",
                        transition: "all 0.2s",
                    }}
                    onFocus={(e) => {
                        e.currentTarget.style.borderColor = "#722ed1";
                        e.currentTarget.style.boxShadow = "0 0 0 3px rgba(114, 46, 209, 0.15)";
                    }}
                    onBlur={(e) => {
                        e.currentTarget.style.borderColor = "#e8e8e8";
                        e.currentTarget.style.boxShadow = "none";
                    }}
                >
                    <SearchOutlined style={{ color: "#999", fontSize: 18, marginRight: 12 }} />
                    {/* 🌐 Global Upload Button */}
                    <input
                        type="file"
                        id="ai-global-upload"
                        accept="image/*,.pdf,.jpg,.jpeg,.png"
                        style={{ display: "none" }}
                        onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (!file) return;

                            pushAIChat(`📄 File received: ${file.name}`);

                            // Send file to GlobalMasterListener
                            window.dispatchEvent(new CustomEvent("ai-file-upload", { detail: { file } }));
                        }}
                    />

                    <input
                        type="text"
                        value={query}
                        autoFocus
                        onChange={(e) => {
                            setQuery(e.target.value);
                            updateSuggestionsList(e.target.value);
                        }}
                        onKeyDown={handleKeyDown}
                        placeholder="Search menus or ask to perform actions..."
                        style={{
                            flex: 1,
                            border: "none",
                            outline: "none",
                            background: "transparent",
                            fontSize: 15,
                        }}
                    />
                    <div
                        onClick={startVoiceInput}
                        style={{
                            marginRight: 10,
                            marginBottom: 8,
                            cursor: "pointer",
                            color: isRecording ? "red" : "#555",
                            fontSize: 20
                        }}
                        title="Speak your command"
                    >
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-label=""
                            className="icon"
                            fontSize="inherit"
                        >
                            <path d="M15.7806 10.1963C16.1326 10.3011 16.3336 10.6714 16.2288 11.0234L16.1487 11.2725C15.3429 13.6262 13.2236 15.3697 10.6644 15.6299L10.6653 16.835H12.0833L12.2171 16.8486C12.5202 16.9106 12.7484 17.1786 12.7484 17.5C12.7484 17.8214 12.5202 18.0894 12.2171 18.1514L12.0833 18.165H7.91632C7.5492 18.1649 7.25128 17.8672 7.25128 17.5C7.25128 17.1328 7.5492 16.8351 7.91632 16.835H9.33527L9.33429 15.6299C6.775 15.3697 4.6558 13.6262 3.84992 11.2725L3.76984 11.0234L3.74445 10.8906C3.71751 10.5825 3.91011 10.2879 4.21808 10.1963C4.52615 10.1047 4.84769 10.2466 4.99347 10.5195L5.04523 10.6436L5.10871 10.8418C5.8047 12.8745 7.73211 14.335 9.99933 14.335C12.3396 14.3349 14.3179 12.7789 14.9534 10.6436L15.0052 10.5195C15.151 10.2466 15.4725 10.1046 15.7806 10.1963ZM12.2513 5.41699C12.2513 4.17354 11.2437 3.16521 10.0003 3.16504C8.75675 3.16504 7.74835 4.17343 7.74835 5.41699V9.16699C7.74853 10.4104 8.75685 11.418 10.0003 11.418C11.2436 11.4178 12.2511 10.4103 12.2513 9.16699V5.41699ZM13.5814 9.16699C13.5812 11.1448 11.9781 12.7479 10.0003 12.748C8.02232 12.748 6.41845 11.1449 6.41828 9.16699V5.41699C6.41828 3.43889 8.02221 1.83496 10.0003 1.83496C11.9783 1.83514 13.5814 3.439 13.5814 5.41699V9.16699Z" />
                        </svg>
                    </div>

                    <div
                        style={{
                            background: query ? "#722ed1" : "#ddd",
                            color: "white",
                            padding: "4px 6px",
                            borderRadius: 6,
                            fontSize: 13,
                            fontWeight: 600,
                            transition: "background 0.2s",
                        }}
                        onClick={handleAISearch}
                    >
                        {/* ⏎ */}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="white"
                        >
                            <path d="M2 21l21-9L2 3v7l15 2-15 2z" />
                        </svg>
                    </div>
                </div>
                <div style={{ marginTop: 8, fontSize: 12, color: "#aaa", textAlign: "center" }}>
                    Powered by Leadchain AI • Try: "Menu Name " or "Apply Leave"
                </div>
            </div>
            {aiLoading && (
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(255,255,255,0.8)",
                        backdropFilter: "blur(3px)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,

                    }}
                >
                    <Spin size="large" tip="Processing..." />
                </div>
            )}
            {isRecording && (
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "linear-gradient(135deg, rgba(99, 102, 241, 0.95) 0%, rgba(168, 85, 247, 0.95) 100%)",
                        backdropFilter: "blur(12px)",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999999,
                        animation: "fadeIn 0.3s ease",
                        marginTop: 50,
                    }}
                >
                    {/* Animated Wave Circles */}
                    <div style={{ position: "relative", width: 120, height: 120 }}>
                        <div className="wave-circle wave-1"></div>
                        <div className="wave-circle wave-2"></div>
                        <div className="wave-circle wave-3"></div>

                        {/* Microphone Icon Container */}
                        <div
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: 70,
                                height: 70,
                                borderRadius: "50%",
                                background: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
                                animation: "pulse 2s ease-in-out infinite",
                            }}
                        >
                            <Mic size={32} color="#6366f1" strokeWidth={2.5} />
                        </div>
                    </div>

                    {/* Listening Text */}
                    <div
                        style={{
                            marginTop: 40,
                            fontSize: 24,
                            fontWeight: 600,
                            color: "white",
                            letterSpacing: "0.5px",
                        }}
                    >
                        Listening<span className="dots">...</span>
                    </div>

                    {/* Subtitle */}
                    <div
                        style={{
                            marginTop: 12,
                            fontSize: 15,
                            color: "rgba(255, 255, 255, 0.8)",
                            fontWeight: 400,
                        }}
                    >
                        Speak your command clearly
                    </div>

                    {/* Waveform Visualization */}
                    <div
                        style={{
                            display: "flex",
                            gap: 4,
                            marginTop: 30,
                            alignItems: "center",
                            height: 40,
                        }}
                    >
                        {[...Array(5)].map((_, i) => (
                            <div
                                key={i}
                                className="wave-bar"
                                style={{
                                    width: 4,
                                    background: "white",
                                    borderRadius: 2,
                                    animationDelay: `${i * 0.1}s`,
                                }}
                            ></div>
                        ))}
                    </div>
                </div>
            )}
        </Drawer>
    );
};

export default AISearchDrawer;